import React from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import Popup from 'reactjs-popup';
import ReactModal from "react-modal";
import { PickList } from 'primereact/picklist'
import { useNavigate } from 'react-router-dom';

// Custom components 
import SglContext from "../SglContext";
import VideoPlayer from "../videos/VideoPlayer";
import ManageCards from "../common/ManageCards";
import PasswordStrengthMeter from "../common/PasswordStrengthMeter"
import TeamManagement from "./teamManagement/teamManagement";
import PendingRequests from "./pendingRequests/pendingRequests";
// Resources
import './myAccount.css';
import './myAccountForm.css'
import './teamManagement/TeamManagement.css'
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./emailNotifications.css"
import "./videoSubscriptions.css";
import "./managecards.css";
import "./iosSubscription.css";
import MyAgreements from "./myAgreements";
import MyInvoices from "./myInvoices";
import indicator_icon from "../images/Indicator.gif";
import video_icon from "../images/video_icon.png";
import download_icon from "../images/download.png";
import calendar_icon from "../images/calendar.png";
import AssociatedPeople from "./manageLists/associatedPeople";
import AssociatedHorses from "./manageLists/associatedHorses";
import { LoadingSpinner } from "./teamManagement/utilities";
import ChangeDefaultCardModal from "./changeDefaultCardModal";

// API END POINTS
// const sgl_webservice_iphone = Sgl.sglApiUrl + '/iphonev2/addentryv2/';
// const sgl_webservice_iphone1 = Sgl.sglApiUrl + '/iphone.php/webservice/';
// const user_info_url = Sgl.nestApiUrl + '/users/getLoggedInUser';
// const sgl_webservice_video = Sgl.nestApiUrl + "/videos/";
// const sgl_webservice_subscription = Sgl.sglApiUrl + '/iphone.php/webservice/SubmitIOSPayment';

// Constants
// const is_mobile = false;
const years = Array.from({ length: 2050 - 2015 + 1 }, (_, i) => 2015 + i)
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

class MyAccount extends React.Component {

  get sgl_webservice_iphone() {
    return this.context.sglApiUrl + '/iphonev2/addentryv2/';
  }

  get sgl_webservice_iphone1() {
    return this.context.sglApiUrl + '/iphone.php/webservice/';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

  get sgl_webservice_video() {
    return this.context.nestApiUrl + '/videos/';
  }

  get sgl_webservice_subscription() {
    return this.context.sglApiUrl + '/iphone.php/webservice/SubmitIOSPayment';
  }

  state = {
    smc_account_settings: {},
    current_tab: 'my_account',
    person_data: {},
    updated_mobile_number: '',
    mobile_phone_error: '',
    mobile_verification_code: '',
    mobile_code_error: '',
    new_email: '',
    verify_email: '',
    email_error: '',
    current_password: '',
    new_password: '',
    confirm_password: '',
    password_error: '',
    is_open_change_mobile_modal: false,
    is_open_verify_mobile_modal: false,
    is_open_change_email_modal: false,
    is_open_success_email_modal: false,
    is_open_change_password_modal: false,
    is_open_success_password_modal: false,
    is_open_subscription_modal: false,
    is_open_success_subscription_modal: false,
    subscription_response: '',
    today: new Date().toISOString().split('T')[0],
    subscription_start_date: new Date().toISOString().split('T')[0],

    // is_mobile: false,

    payment_methods: [],
    check_card_email_phone_info: false,
    check_address_info: false,
    is_open_manage_card_modal: false,
    is_open_add_card_modal: false,
    default_payment_method_id: null,
    has_default_payment_method: false,

    video_subscriptions: [],
    video_receipt_file_path: '',

    ios_result: {},
    ios_result_shows: [],
    ios_sub_type: 'premium',
    ios_sub_option: null,
    ios_sub_option_days: null,
    startDate: new Date(),
    subscription_options: [],
    shows_list: [],
    selected_show: -1,
    selected_payment_method: -1,

    email_notifications: {},
    is_open_show_companies_modal: false,

    orders_list: [],
    order_invoice_file_path: '',
    is_open_order_detail_modal: false,
    order_detail: {},

    bookings_list: [],
    is_open_booking_detail_modal: false,
    booking_detail: {},
    booking_data: {},
    single_booking: {},

    save_account_error_msg: '',
    save_account_success_msg: '',

    current_show: localStorage.getItem('show_id'),
    loose_class_heading: '',
    div_type: "my_account",
    class_type: "Jumpers",
    show_name: '',

    videos_list: [],
    is_videos_enabled: false,
    video_to_play: {},
    playing_video: false,
    is_open_play_video_modal: false,
    is_open_do_subscription_modal: false,

    loading: true,
    userData: {},
    is_admin: false,

    numbers: ["1", "2", "3", "4", "5", "6"],
    letters: ["A", "B", "C", "D", "E", "F"],
    isHoveringNumbers: false,
    isHoveringLetters: false,
    isDragging: false,

    horseListSource: [],
    horseListTarget: [],
    peopleListSource: [],
    peopleListTarget: [],

    desktopTabs: [],
    mobileTabs: [],

    // For display of elements
    verify_mobile_please_wait: false,
    verifyMobile_btn: true,
    verify_mobile_modal_please_wait: false,
    change_mobile_button: true,
    verify_otp_error_summary: false,
    verify_otp_button: true,
    update_btn_section: true,
    change_password_please_wait: false,
    change_password_button: true,
    change_email_please_wait: false,
    change_email_button: true,
    verify_otp_please_wait: false,
    sidebarCollapsed: false,
    isMobileMenuOpen: false,

    // change Default credit card 
    is_open_change_default_card_modal: false,
    is_changing_default_card: false,
  }

  constructor() {
    super();
    this.VideoPlayerElement = React.createRef();
    this.VideoSubscriptionElement = React.createRef();
    // bind function in constructor instead of render
    this.openChangeMobileModal = this.openChangeMobileModal.bind(this);
    this.closeChangeMobileModal = this.closeChangeMobileModal.bind(this);

    this.openVerifyMobileModel = this.openVerifyMobileModel.bind(this);
    this.closeVerifyMobileModel = this.closeVerifyMobileModel.bind(this);
    this.verifyMobileCode = this.verifyMobileCode.bind(this);

    this.renderDatePicker = this.renderDatePicker.bind(this);

    this.openChangeEmailModal = this.openChangeEmailModal.bind(this);
    this.closeChangeEmailModal = this.closeChangeEmailModal.bind(this);
    this.changeEmail = this.changeEmail.bind(this);

    this.openSuccessEmailModal = this.openSuccessEmailModal.bind(this);
    this.closeSuccessEmailModal = this.closeSuccessEmailModal.bind(this);

    this.openChangePasswordModal = this.openChangePasswordModal.bind(this);
    this.closeChangePasswordModal = this.closeChangePasswordModal.bind(this);
    this.changePassword = this.changePassword.bind(this);

    this.openSuccessPasswordModal = this.openSuccessPasswordModal.bind(this);
    this.closeSuccessPasswordModal = this.closeSuccessPasswordModal.bind(this);

    this.openManageCardsModal = this.openManageCardsModal.bind(this);
    this.closeSelectCardModal = this.closeSelectCardModal.bind(this);

    this.getPaymentMethods = this.getPaymentMethods.bind(this);

    this.openShowCompaniesModal = this.openShowCompaniesModal.bind(this);
    this.closeShowCompaniesModal = this.closeShowCompaniesModal.bind(this);

    this.openSuccessOrderDetailModal = this.openSuccessOrderDetailModal.bind(this);
    this.closeSuccessOrderDetailModal = this.closeSuccessOrderDetailModal.bind(this);

    this.openSuccessBookingDetailModal = this.openSuccessBookingDetailModal.bind(this);
    this.closeSuccessBookingDetailModal = this.closeSuccessBookingDetailModal.bind(this);

    this.closeModal = this.closeModal.bind(this);
    this.closeSubscriptionModal = this.closeSubscriptionModal.bind(this);
    this.playVideoAfterSubscribe = this.playVideoAfterSubscribe.bind(this);

    this.horseTemplate = this.horseTemplate.bind(this);
    this.onHorseListChange = this.onHorseListChange.bind(this);
    this.peopleTemplate = this.peopleTemplate.bind(this);
    this.onPeopleListChange = this.onPeopleListChange.bind(this);

    this.openSubscriptionModal = this.openSubscriptionModal.bind(this)
    this.closeSubModal = this.closeSubModal.bind(this)

    this.openSuccessSubscriptionModal = this.openSuccessSubscriptionModal.bind(this)
    this.closeSubSuccesModal = this.closeSubSuccesModal.bind(this)

    this.renderCustomHeader = this.renderCustomHeader.bind(this);

    this.mobileMenuRef = React.createRef();
  }

  componentDidMount() {
    document.title = "My Account";

    this.getAllData();
    // if (is_mobile == 1) {
    //   this.setState({
    //     is_mobile: is_mobile,
    //   });
    // }

    window.addEventListener('hashchange', this.handleHashChange);
    this.handleHashChange();

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);

    window.removeEventListener('hashchange', this.handleHashChange);
  }

  handleHashChange = () => {
    const hash = window.location.hash.substring(1); // Remove the # symbol
    
    if (hash && this.state.desktopTabs && this.state.desktopTabs.length > 0) {
      const validTabs = this.state.desktopTabs.filter(tab => tab.show).map(tab => tab.name);
      
      if (validTabs.includes(hash)) {
        this.switchTab(hash);
      }
    }
  }

  handleBackToShowGrounds = () => {
    const backUrl = "/";
    if(this.context.company_id == -1){
      window.location.href = 'https://showgroundslive.com';
    }else{
      this.props.navigate(backUrl);
    }
    
  }

  handleClickOutside = (event) => {
    if (this.mobileMenuRef.current && !this.mobileMenuRef.current.contains(event.target)) {
      if (this.state.isMobileMenuOpen) {
        this.setState({ isMobileMenuOpen: false });
      }
    }
  }

  onHorseListChange(event) {
    this.setState({
      horseListSource: event.source,
      horseListTarget: event.target
    });
    var excluded_horses = [];
    if (this.state.horseListTarget.length > 0) {
      this.state.horseListTarget.forEach((key, index) => {
        excluded_horses.push(this.state.horseListTarget[index].horse_id);
      })
    }
  }
  onPeopleListChange(event) {
    this.setState({
      peopleListSource: event.source,
      peopleListTarget: event.target
    });
    var excluded_people = [];
    if (this.state.peopleListTarget.length > 0) {
      this.state.peopleListTarget.forEach((key, index) => {
        excluded_people.push(this.state.peopleListTarget[index].people_id);
      })
    }
  }
  horseTemplate(horse) {
    return (
      <div className="product-item">
        <p id={horse.horse_id}>{horse.horse_name}</p>
      </div>
    );
  }
  peopleTemplate(person) {
    return (
      <div className="product-item">
        <p id={person.people_id}>{person.people_name}</p>
      </div>
    );
  }

  handleChange = (date, event) => {
    date = new Date(date)
    // let month = date.getMonth()
    // let dates = date.getDate()
    // if (date.getMonth() + 1 < 10)
    //   month = "0" + (date.getMonth() + 1)
    // else
    //   month = (date.getMonth() + 1)

    // if (date.getDate() < 10)
    //   dates = "0" + date.getDate()
    // else
    //   dates = date.getDate()

    // date = date.getFullYear() + '-' +date.getMonth() + '-' + date.getDate();
    // date = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    date =  parseInt(date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();

    this.setState({ subscription_start_date: date });
  };

  renderCustomHeader = (date) => {
    return (
      <div
        style={{
          margin: 10,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <select
          value={date.date.getFullYear()}
          onChange={({ target: { value } }) => date.changeYear(value)}
        >
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <select
          value={months[date.date.getMonth()]}
          onChange={({ target: { value } }) =>
            date.changeMonth(months.indexOf(value))
          }
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    )
  }
  renderDatePicker = () => {
    // if (this.context.is_mobile) {
    //    return <input type="date" id="subscription_start" value={this.state.subscription_start_date.split('/').join('-')} name="subscription_start" min={this.state.today} onChange={this.handleChange}></input>;
    // }
    return (
      <DatePicker
        id="datepicker"
        calendarClassName="subscription_start"
        name="subscription_start"
        minDate={new Date()}
        renderCustomHeader={this.renderCustomHeader}
        dateFormat={"MM/dd/yyyy"}
        selected={new Date(this.state.subscription_start_date)}
        onChange={this.handleChange}
      />
      
    );
  }
  

  getAllData() {
    this.getUserData();
    this.getMyVideos();
    this.getAssociatedHorsesAndPeople();
    axios.all([
      axios.get(this.sgl_webservice_iphone + 'GetPaymentMethods', {
        params: {
          company_id: this.context.company_id,
        }
      }),
      axios.get(this.sgl_webservice_iphone1 + 'EditAccount', {
        params: {
          customer_id: this.context.company_id
        }
      }),
    ]).then(axios.spread((paymentMethods, account) => {
      this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath + '/myaccount');

      let desktopTabs = [
        { name: 'my_account', display: 'My Account', show: true },
        { name: 'pending_requests', display: 'Pending Requests', show: true },
        { name: 'team_management', display: 'Team Management', show: true },
        { name: 'my_agreements', display: 'My Agreements', show: true },
        { name: 'my_invoices', display: 'My Invoices', show: true },
        { name: 'manage_cards', display: 'Payment Methods', show: !account.data.smc_account_settings.hide_manage_cards },
        { name: 'manage_people', display: 'Manage People', show: !account.data.smc_account_settings.hide_manage_people },
        { name: 'manage_horses', display: 'Manage Horses', show: !account.data.smc_account_settings.hide_manage_horses },
        { name: 'video_subscriptions', display: 'My Video Subscriptions', show: !account.data.smc_account_settings.hide_video_subscriptions },
        { name: 'ios_subscriptions', display: 'iOS Subscriptions', show: !account.data.smc_account_settings.hide_ios_subscriptions },
        { name: 'email_notifications', display: 'Email Notifications', show: !account.data.smc_account_settings.hide_email_notifications },
        { name: 'my_orders', display: 'My Orders', show: !account.data.smc_account_settings.hide_my_orders },
        { name: 'my_bookings', display: 'My Bookings', show: !account.data.smc_account_settings.hide_my_bookings },
      ]
      let mobileTabs = [
        { name: 'my_account', display: 'My Account', show: true },
        { name: 'pending_requests', display: 'Pending Requests', show: true },
        { name: 'team_management', display: 'Team Management', show: true },
        { name: 'my_agreements', display: 'My Agreements', show: true },
        { name: 'my_invoices', display: 'My Invoices', show: true },
        { name: 'manage_cards', display: 'Payment Methods', show: !account.data.smc_account_settings.hide_manage_cards },
        { name: 'manage_people', display: 'Manage People', show: !account.data.smc_account_settings.hide_manage_people },
        { name: 'manage_horses', display: 'Manage Horses', show: !account.data.smc_account_settings.hide_manage_horses },
        { name: 'video_subscriptions', display: 'My Video Subscriptions', show: !account.data.smc_account_settings.hide_video_subscriptions },
        { name: 'ios_subscriptions', display: 'iOS subscriptions', show: !account.data.smc_account_settings.hide_ios_subscriptions },
        { name: 'email_notifications', display: 'Email Notifications', show: !account.data.smc_account_settings.hide_email_notifications },
        { name: 'my_orders', display: 'My Orders', show: !account.data.smc_account_settings.hide_my_orders },
        { name: 'my_bookings', display: 'My Bookings', show: !account.data.smc_account_settings.hide_my_bookings },
      ]

      this.setState({
        payment_methods: paymentMethods.data.payment_methods ? paymentMethods.data.payment_methods : [],
        bank_accounts: account.data.bank_accounts ? account.data.bank_accounts : [],
        ach_enabled: account.data.ach_enabled,
        check_card_email_phone_info: paymentMethods.data.check_card_email_phone_info,
        check_address_info: paymentMethods.data.check_address_info,
        smc_account_settings: account.data.smc_account_settings ? account.data.smc_account_settings : [],
        desktopTabs,
        mobileTabs,
        person_data: account.data.sgl_user ? account.data.sgl_user : {},
        video_subscriptions: account.data.video_subscriptions ? account.data.video_subscriptions : [],
        ios_result: account.data.ios_result ? account.data.ios_result : {},
        ios_result_shows: (account.data.ios_result && account.data.ios_result.shows) ? this.filterCompanyShows(account.data.ios_result.shows) : [],
        subscription_start_date: account.data.ios_result && account.data.ios_result.suggested_date ? this.format_date(account.data.ios_result.suggested_date) : new Date().toISOString().split('T')[0],
        subscription_options: account.data.subscription_options ? account.data.subscription_options : [],
        email_notifications: account.data.email_notifications ? account.data.email_notifications : [],
        // show_companies_list: account.data.show_companies ? account.data.show_companies : [],
        show_companies_list: account.data.show_companies ? 
        account.data.show_companies.sort((a, b) => a.name.localeCompare(b.name)) : 
        [],
        orders_list: account.data.orders ? account.data.orders : [],
        bookings_list: account.data.bookings ? account.data.bookings : [],
        loading: false,
      }, () => {
        this.handleHashChange();
      })
    }))  .catch(error => {
    // Log error and set loading to false
    console.error('Error loading account data:', error);
    
    // Set default values so page can still load
    this.setState({
      payment_methods: [],
      bank_accounts: [],
      ach_enabled: false,
      check_card_email_phone_info: false,
      check_address_info: false,
      smc_account_settings: {},
      desktopTabs: [
        { name: 'my_account', display: 'My Account', show: true },
        { name: 'pending_requests', display: 'Pending Requests', show: true },
        { name: 'team_management', display: 'Team Management', show: true },
        { name: 'my_agreements', display: 'My Agreements', show: true },
        { name: 'my_invoices', display: 'My Invoices', show: true },
      ],
      mobileTabs: [
        { name: 'my_account', display: 'My Account', show: true },
        { name: 'pending_requests', display: 'Pending Requests', show: true },
        { name: 'team_management', display: 'Team Management', show: true },
        { name: 'my_agreements', display: 'My Agreements', show: true },
        { name: 'my_invoices', display: 'My Invoices', show: true },
      ],
      person_data: {},
      loading: false
    });
  });

  }
  getAssociatedHorsesAndPeople() {
    axios.get(this.context.sglApiUrl + '/iphone.php/' + this.context.company_urlpath + '/webservice/GetAssocaitedHorsesAndPeople', {
      params: {
        company_id: this.context.company_id
      }
    }).then(results => {
      var available_horses = [];
      var excluded_horses = [];
      var available_people = [];
      var excluded_people = [];
      results.data.associated_horses.sort((a, b) => (a.horse_name > b.horse_name) ? 1 : -1);
      results.data.associated_horses.forEach((key, index) => {
        var horse_data = results.data.associated_horses[index];
        if (horse_data.excluded == "true") {
          excluded_horses.push(results.data.associated_horses[index]);
        } else {
          available_horses.push(results.data.associated_horses[index]);
        }
      })
      results.data.associated_people.sort((a, b) => (a.people_name > b.people_name) ? 1 : -1);
      results.data.associated_people.forEach((key, index) => {
        var people_data = results.data.associated_people[index];
        if (people_data.excluded == "true") {
          excluded_people.push(results.data.associated_people[index]);
        } else {
          available_people.push(results.data.associated_people[index]);
        }
      })
      this.setState({
        horseListSource: available_horses,
        horseListTarget: excluded_horses,
        peopleListSource: available_people,
        peopleListTarget: excluded_people
      })
    })
  }

  getPaymentMethods = () => {
    return new Promise((resolve) => {
      // Fetch both payment methods AND default payment method
      axios.all([
        axios.get(this.sgl_webservice_iphone + 'GetPaymentMethods', {
          params: {
            company_id: this.context.company_id
          }
        }),
        axios.get(this.context.nestApiUrl + '/billing/getAccountPaymentMethod', {
          params: {
            user_id: this.context.current_user?.sgl_id,
            company_id: this.context.company_id
          }
        })
      ]).then(axios.spread((paymentMethods, defaultPaymentMethodRes) => {
        this.setState({
          payment_methods: paymentMethods.data.payment_methods,
          check_card_email_phone_info: paymentMethods.data.check_card_email_phone_info,
          check_address_info: paymentMethods.data.check_address_info,
          defaultPaymentMethod: defaultPaymentMethodRes.data,  
          loading: false
        }, () => {
          resolve();
        });
      }));
    });
  }
  isDefaultCard = (cardId) => {
    return this.state.defaultPaymentMethod?.fingerprint_id == cardId;
  }

  // Check if conditions are met to show Platform Fee section
  shouldShowPlatformFeeSection = () => {
    const isUserVerified = this.context.current_user.userVerfied;
    const isOnboardingMilestoneEnabled = this.context.isOnboardingMilestoneEnabled;

    return isUserVerified && isOnboardingMilestoneEnabled;
  }

  getDefaultCard = () => {
    if (!this.state.defaultPaymentMethod?.fingerprint_id) return null;
    
    return this.state.payment_methods.find(
      card => card.sgl_id == this.state.defaultPaymentMethod.fingerprint_id
    );
  }

  SaveCreditCard(card_data) {

    axios.get(this.sgl_webservice_iphone + 'SaveCreditCard', {
      params: {
        card_data: card_data,
        company_id: this.context.company_id
      }
    }).then(results => {
      this.handleSaveCreditCardData(results.data);
    })
  }

  getExpYearsArray() {
    var years_array = [];
    var now = new Date().getFullYear() - 1;
    const years = Array(now - (now - 20)).fill('').map((v, idx) => now + idx);
    years.forEach(year => {
      years_array.push({
        year_name: year,
        year_value: year
      })
    });
    return years_array;
  }
  

  switchTab(tabName) {
    let update_btn_section = true
    if (tabName == "manage_cards" || tabName == "ios_subscriptions" || tabName == "my_orders" || tabName == "my_bookings" || tabName == "team_management" || tabName == "pending_requests" || tabName == "manage_people" || tabName == "manage_horses" || tabName == "my_agreements" || tabName == "my_invoices" ) {
      update_btn_section = false
    }
    this.setState({ current_tab: tabName, update_btn_section: update_btn_section, 
      save_account_error_msg: "" });

    // Load payment methods when switching to manage_cards tab
    if (tabName === "manage_cards") {
      this.getPaymentMethods();
    }
    window.history.replaceState(null, null, `#${tabName}`);
  }

  /////////// videos functions //////////////
  getMyVideos() {
  return false;
    axios.get(this.sgl_webservice_video + 'myVideos', {
      params: {

        customer_id: this.context.company_id
      }
    })
      .then((res) => {
        this.setState({
          videos_list: res.data.exc_videos,
        })
      });
  }
  getVideosList(uuid) {
    return false;
    var trip = this.state.videos_list.find(v => (v.uuid == uuid));
    if (trip) {
      var videos = trip.videos;
      return videos;
    }
    return [];
  }
  playFirstVideoFromList(uuid){
    var trip = this.state.videos_list.find(v => (v.uuid == uuid));
    if(trip) {
      this.playVideoAPICall(trip.videos[0].sgl_id)
    }
    return;
  }
  playVideo = (video_id) => (e) => {
    this.playVideoAPICall(video_id);
  }
  playVideoAPICall(video_id) {

    localStorage.setItem('playing_video_id', video_id);
    localStorage.setItem('playing_video_url', window.location.pathname.replace(this.context.basePath, '') + window.location.search);
    axios.get(this.sgl_webservice_video + 'play/' + video_id, {
      params: {
        customer_id: this.context.company_id
      }
    })
      .then((res) => {
        this.closeSubscriptionModal();
        localStorage.removeItem("playing_video_id");
        localStorage.removeItem("playing_video_url");
        if (res.data.subscribed_to_play) {
          this.setState({
            video_to_play: res.data.video,
            is_admin: res.data.is_admin,
            is_open_play_video_modal: true,
            playing_video: true
          })
        } else {
          this.setState({
            video_to_play: res.data.video,
            is_admin: res.data.is_admin,
            is_open_do_subscription_modal: true,
            playing_video: true
          })
        }
      });
  }

  closeModal() {
    this.setState({
      is_open_play_video_modal: false,
      playing_video: false
    });
  }
  closeSubscriptionModal() {
    this.setState({
      is_open_do_subscription_modal: false,
      playing_video: false
    });

  }
  playVideoAfterSubscribe() {
    this.playVideoAPICall(this.state.video_to_play.videos_sgl_id);
    this.setState({ playing_video: true });
  }

  getVideoTitle(video) {
    if (video['class_type'] == 'Jumpers') {
      if (video['trip_type'].toLowerCase() != 'jo') {
        return " (R1)";
      } else {
        return " (JO)";
      }
    }
  }


  /////////// end videos functions /////////


  /////////// my account functions ////////////////////


  updateNewPersonData(evt, field) {
    var people_data = this.state.person_data;
    people_data[field] = evt.target.value;

    this.setState({
      person_data: people_data
    });
  }
  updateMobileNumberValue(evt, field) {
    this.setState({
      updated_mobile_number: evt.target.value
    });
  }

  updateVerificationCodeValue(evt) {
    this.setState({
      mobile_verification_code: evt.target.value
    });
  }
  updateEmailValue(evt) {
    this.setState({
      new_email: evt.target.value
    });
  }

  updateVerifyEmailValue(evt) {
    this.setState({
      verify_email: evt.target.value
    });
  }
  updateOldPasswordValue(evt) {
    this.setState({
      current_password: evt.target.value
    });
  }
  updateNewPasswordValue(evt) {
    this.setState({
      new_password: evt.target.value
    });
  }
  updateConfirmPasswordValue(evt) {
    this.setState({
      confirm_password: evt.target.value
    });
  }


  openChangeMobileModal() {
    this.setState({
      is_open_change_mobile_modal: true,
    });
  }

  onInputchange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  closeChangeMobileModal() {
    this.setState({
      mobile_phone_error: '',
      is_open_change_mobile_modal: false,
      verify_mobile_modal_please_wait: false
    });
  }

  openVerifyMobileModel() {
    this.setState({
      mobile_phone_error: '',
      verify_mobile_modal_please_wait: true,
      change_mobile_button: false
    });

    this.verifyMobileNumberApiCall(this.state.updated_mobile_number, true);
  }

  verifyMobileNumber = () => (e) => {
    var updated_mobile_number = this.state.person_data.phonenumber;
    if (!updated_mobile_number || updated_mobile_number == '') {
      this.setState({ save_account_error_msg: 'Please provide a mobile number.' });
    } else {
      this.setState({
        save_account_error_msg: '',
        verify_mobile_please_wait: true,
        verifyMobile_btn: false,
        verify_otp_error_summary: false
      });

      this.verifyMobileNumberApiCall(updated_mobile_number, false);
    }
  }

  verifyMobileNumberApiCall(updated_mobile_number, from_modal) {
    axios.get(this.sgl_webservice_iphone1 + 'VerifyMobilePhone', {
      params: {
        mobile_phone: updated_mobile_number,
        user_id: this.state.userData.sgl_id,
        updateVerified: true
      }
    })
      .then((response) => {
        if (from_modal) {
          this.setState({ verify_mobile_modal_please_wait: false, change_mobile_button: true })
        } else {
          this.setState({ verify_mobile_please_wait: false, verifyMobile_btn: true })
        }

        if (response.data.result) {
          var people_data = this.state.person_data;
          people_data.phonenumber = updated_mobile_number;
          people_data.phonenumber_verified = false;
          this.setState({ is_open_verify_mobile_modal: true, person_data: people_data });
        } else {
          if (from_modal) {
            this.setState({ mobile_phone_error: response.data.error });
          } else {
            this.setState({ save_account_error_msg: response.data.error });
          }
        }
      });
  }

  closeVerifyMobileModel() {
    this.setState({
      is_open_verify_mobile_modal: false,
      is_open_change_mobile_modal: false,
    });
  }

  verifyMobileCode() {
    this.setState({
      verify_otp_error_summary: false,
      verify_otp_button: false,
      verify_otp_please_wait: true
    })

    this.verifyMobileOTPApiCall();
  }

  verifyMobileOTPApiCall() {
    axios.get(this.sgl_webservice_iphone1 + 'VerifyOTP', {
      params: {
        otp: this.state.mobile_verification_code,
      }
    })
      .then((response) => {
        this.setState({ verify_otp_please_wait: false })

        if (response.data.result) {
          var person_data = this.state.person_data;
          person_data.phonenumber_verified = true;
          this.setState({
            is_open_verify_mobile_modal: false,
            is_open_change_mobile_modal: false,
            person_data: person_data,
            verifyMobile_btn: false
          });
        } else {
          this.setState({ verify_otp_error_summary: true, verify_otp_button: true })
        }
      });
  }

  openChangeEmailModal() {
    this.setState({
      email_error: '',
      is_open_change_email_modal: true,
    });
  }

  closeChangeEmailModal() {
    this.setState({
      is_open_change_email_modal: false,
    });
  }

  changeEmail() {
    this.setState({
      email_error: '',
      change_email_please_wait: true,
      change_email_button: false
    });

    this.changeEmailApiCall(this.state.new_email, this.state.verify_email);
  }
  changeEmailApiCall(new_email, confirm_email) {
    axios.get(this.sgl_webservice_iphone1 + 'ChangeUserEmail', {
      params: {
        customer_id: this.context.company_id,
        site_url: `${window.location.protocol}//${window.location.host}${(this.context.basePath != '/' && this.context.basePath != '')?`${this.context.basePath}`:""}`,
        new_email: new_email,
        confirm_email: confirm_email
      }
    })
      .then((response) => {
        this.setState({ change_email_please_wait: false, change_email_button: true })
        if (response.data.success) {
          this.setState({
            is_open_change_email_modal: false,
            is_open_success_email_modal: true
          });
        } else {
          this.setState({ email_error: response.data.errors });
        }
      });
  }
  openSuccessEmailModal() {
    this.setState({
      is_open_success_email_modal: true,
    });
  }

  closeSuccessEmailModal() {
    this.setState({
      is_open_success_email_modal: false,
      new_email: '',
      verify_email: '',
      email_error: '',
    });
  }

  openChangePasswordModal() {
    this.setState({
      password_error: '',
      is_open_change_password_modal: true,
    });
  }

  closeChangePasswordModal() {
    this.setState({
      change_password_please_wait: false,
      is_open_change_password_modal: false,
    });
  }
  changePassword() {
    this.setState({
      password_error: '',
      change_password_please_wait: true,
      change_password_button: false
    });

    this.changePasswordApiCall(this.state.current_password, this.state.new_password, this.state.confirm_password);
  }

  changePasswordApiCall(current_password, new_password, confirm_password) {
    axios.get(this.sgl_webservice_iphone1 + 'ChangeUserPassword', {
      params: {
        current_password: current_password,
        new_password: new_password,
        confirm_password: confirm_password,
      }
    })
      .then((response) => {
        this.setState({ change_password_please_wait: false, change_password_button: true })

        if (response.data.success) {
          this.setState({
            is_open_change_password_modal: false,
            is_open_success_password_modal: true,
          });
        } else {
          this.setState({ password_error: response.data.errors });
        }
      });
  }
  openSuccessPasswordModal() {
    this.setState({
      is_open_success_password_modal: true,
    });
  }

  closeSuccessPasswordModal() {
    this.setState({
      is_open_success_password_modal: false,
      current_password: '',
      new_password: '',
      confirm_password: '',
      password_error: '',

    });
  }

  /////////// end my Account functions ////////////////////


  /////////////// manage cards functions ////////////////////

  openManageCardsModal() {
    this.setState({
      is_open_manage_card_modal: true,
    });
  }

  closeSelectCardModal() {
    this.setState({
      is_open_manage_card_modal: false,
    });

  }

  // Open change default card modal
  openChangeDefaultCardModal = () => {
    this.setState({ is_open_change_default_card_modal: true });
  }

  // Close change default card modal
  closeChangeDefaultCardModal = () => {
    this.setState({ is_open_change_default_card_modal: false });
  }

  // Handle success - refresh data and close modal
  handleChangeDefaultCardSuccess = () => {
    this.getPaymentMethods(); // Refresh payment methods
  }
  /////////// end manage cards functions ////////////////////

  /////////// video subscriptions functions ///////////////////

  getVideoDownloadPath(subscription_id) {
    var path = this.sgl_webservice_iphone1 + 'DownloadVideoReceipt?subscription_id=' + subscription_id + '&customer_id=' + this.context.company_id
    return path;
  }

  downloadReceipt = (Subscription_id) => (e) => {

    this.downloadVideoReceiptApiCall(Subscription_id);
  }
  downloadVideoReceiptApiCall(Subscription_id) {
    axios.get(this.sgl_webservice_iphone1 + 'DownloadVideoReceipt', {
      params: {
        subscription_id: Subscription_id,
        customer_id: this.context.company_id
      }
    })
      .then((response) => {
        if (response.data.file_path) {
          this.setState({
            video_receipt_file_path: response.data.file_path,
          });
        }
      });
  }
  /////////// video subscriptions functions ///////////////////

  /////////// ios subscriptions functions ///////////////////
  setIosSubType = (event) => {
    this.setState({
      ios_sub_type: event.target.value
    });
  }

  setIosSubOption = (event) => {
    this.setState({
      ios_sub_option: event.target.value,
      ios_sub_type: "premium",
      ios_sub_option_days: this.state.subscription_options.find((option) => option.sgl_id == event.target.value).sku
    });
  }

  setSelectedShow(evt, field) {
    this.setState({
      selected_show: evt.target.value,
      ios_sub_type: "single_event",
      single_show: this.state.ios_result_shows.find((show) => show.show_id == evt.target.value),
      show_name: this.state.ios_result_shows.find((show) => show.show_id == evt.target.value).show_name
    });
  }

  onPaymentMethodSelect(e) {
    if (e.target.value == 'ManageCards') {
      this.openManageCardsModal();
      this.setState({
        selected_payment_method: '-1',
      });
    } else {
      this.setState({
        selected_payment_method: e.target.value,
      });
    }
  }

  getExtendDate(days_to_add) {
    var suggested_date = (new Date(this.state.subscription_start_date));
    suggested_date.setDate(suggested_date.getDate() + days_to_add);
    return this.format_date(suggested_date);
  }

  /////////// end ios subscriptions functions ///////////////////

  ///////////// email notification functions ////////////////////

  updateEmailNotificationsData(e, field) {
    var email_notifications = this.state.email_notifications;
    email_notifications[field] = e.target.checked

    this.setState({
      email_notifications: email_notifications
    });

  }

  updateEmailNotifCompaniesList(e, URLpath) {
    var companies_list = this.state.show_companies_list;
    var unsubscribed = e.target.checked;
    companies_list = companies_list.map(el => (el.URLpath === URLpath ? { ...el, unsubscribed } : el));

    this.setState({
      show_companies_list: companies_list
    });
  }


  openShowCompaniesModal() {
    this.setState({
      is_open_show_companies_modal: true,
    });
  }

  closeShowCompaniesModal() {
    this.setState({
      is_open_show_companies_modal: false,
    });

  }

  ///////////// end email notification functions ////////////////////

  /////////// my Orders functions ///////////////////
  getOrderInvoiveDownloadPath(invoice_id) {
    // /viewPDF.php?id={$order->invoice_id}&type=Invoice&category=1&ShowManagementID={customer_id}
    var path = this.context.sglApiUrl + '/viewPDF.php?id=' + invoice_id + '&type=Invoice&category=1&ShowManagementID=' + this.context.company_id
    return path;
  }

  downloadOrderInvoice = (Order_id) => (e) => {

    this.downloadOrderInvoiceApiCall(Order_id);
  }
  downloadOrderInvoiceApiCall(Order_id) {
    axios.get(this.sgl_webservice_iphone1 + 'DownloadOrderInvoice', {
      params: {
        Order_id: Order_id,
        customer_id: this.context.company_id
      }
    })
      .then((response) => {
        if (response.data.file_path) {
          this.setState({
            order_invoice_file_path: response.data.file_path,
          });
        }
      });
  }

  openSuccessOrderDetailModal = (order_id) => (e) => {
    this.getOrderDetailApiCall(order_id);
  }
  getOrderDetailApiCall(order_id) {
    axios.get(this.sgl_webservice_iphone1 + 'GetOrderDetails', {
      params: {
        order_id: order_id,
        customer_id: this.context.company_id
      }
    })
      .then((response) => {
        if (response.data) {
          this.setState({
            is_open_order_detail_modal: true,
            order_detail: response.data,
          });
        }
      });
  }

  closeSuccessOrderDetailModal() {
    this.setState({
      is_open_order_detail_modal: false,
      order_detail: {},
    });
  }
  /////////// end my Orders functions ///////////////////

  ////////// my booking functions /////////////////////
  openSuccessBookingDetailModal = (booking_id) => (e) => {

    this.getBookingDetailApiCall(booking_id);
  }
  getBookingDetailApiCall(booking_id) {
    axios.get(this.sgl_webservice_iphone1 + 'GetBookingDetails', {
      params: {
        order_id: booking_id,
        customer_id: this.context.company_id
      }
    })
      .then((response) => {
        if (response.data) {
          this.setState({
            is_open_booking_detail_modal: true,
            booking_detail: response.data,
            booking_data: response.data.booking_data ? response.data.booking_data : {},
            single_booking: response.data.booking_data.EntityReservationBookings ? response.data.booking_data.EntityReservationBookings[0] : {},
          });
        }
      });
  }

  closeSuccessBookingDetailModal() {
    this.setState({
      is_open_booking_detail_modal: false,
      order_detail: {},
    });
  }

  getOccupency(booking) {
    var occupancy = "";
    var adults = parseInt(booking.adults);
    var children = parseInt(booking.children);
    if ((adults > 0)) {
      occupancy = adults;
      if (adults > 1) {
        occupancy += " Adults";
      }
      else {
        occupancy += " Adult";
      }
    }
    if ((adults > 0) && (children > 0)) {
      occupancy += " and";
    }
    if ((children > 0)) {
      occupancy += (" " + children);
      if (children > 1) {
        occupancy += " Children";
      }
      else {
        occupancy += " Child";
      }
    }
    if (occupancy == "") {
      occupancy = "N/A";
    }
    return occupancy
  }

  getCalendarPath(order_id, entity_names) {
    // "bookings/createCalenderEntry/booking_order_id/"+order_id+"/entity_names/"+entity_names
    var path = this.context.sglApiUrl + "/bookings/createCalenderEntry/booking_order_id/" + order_id + "/entity_names/" + entity_names
    return path;
  }
  ///////////end my booking functions

  //////////// saving data functions ///////////////
  saveEditAccount = () => (e) => {
    this.setState({ save_account_error_msg: '', save_account_success_msg: '' })

    var companies = {};
    this.state.show_companies_list.forEach(company => {
      companies[company.URLpath] = company.unsubscribed;
    });
    var notifs_list = Object.assign(this.state.email_notifications, companies);
    this.saveEditAccountApiCall(this.state.person_data, notifs_list);
  }

  saveEditAccountApiCall(person_data, email_notifications_data) {
    var excluded_horses = [];
    var excluded_people = [];
    if (this.state.horseListTarget.length > 0) {
      this.state.horseListTarget.forEach((key, index) => {
        excluded_horses.push(this.state.horseListTarget[index].horse_id);
      })
    }
    if (this.state.peopleListTarget.length > 0) {
      this.state.peopleListTarget.forEach((key, index) => {
        excluded_people.push(this.state.peopleListTarget[index].people_id);
      })
    }
    axios.post(this.sgl_webservice_iphone1 + 'SaveAccount', null, {
      params: {
        first_name: person_data.first,
        last_name: person_data.last_name,
        hAddress: person_data.address,
        hCity: person_data.city,
        hState: person_data.state,
        hPostalCode: person_data.postal_code,
        email_notifications_data: email_notifications_data,
        associated_horses: excluded_horses,
        associated_people: excluded_people,
        customer_id: this.context.company_id
      }
    })
      .then(results => {

        if (results.data.success) {
          this.setState({ save_account_error_msg: '', save_account_success_msg: 'Your changes are updated successfully' });
          this.switchTab('my_account');
        } else {
          this.setState({ save_account_error_msg: results.data.error_message });
        }
      });
  }
  //////////// end saving data functions ///////////////

  format_time(timeString) {
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = (H < 12 || H === 24) ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  }
  format_date(unformatted_date) {
    if (!unformatted_date || unformatted_date == '0000-00-00') {
      return '';

    }
    var unformatted_date_split = (unformatted_date && unformatted_date.split) ? unformatted_date.split('T')[0] : unformatted_date;
    var formatted_date = (new Date(unformatted_date_split));
    formatted_date = new Date(formatted_date.toISOString());
    return parseInt(formatted_date.getMonth() + 1) + "/" + formatted_date.getDate() + "/" + formatted_date.getFullYear();
  }
  format_starting_date(unformatted_date) {
    if (!unformatted_date || unformatted_date == '0000-00-00') {
      return '';

    }
    var unformatted_date_split = (unformatted_date && unformatted_date.split) ? unformatted_date.split('T')[0] : unformatted_date;
    var formatted_date = (new Date(unformatted_date_split));
    formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
    return formatted_date.getFullYear() + '/' + parseInt(formatted_date.getMonth() + 1) + '/' + formatted_date.getDate();

    // return parseInt(formatted_date.getMonth() + 1) + "/" + formatted_date.getDate() + "/" + formatted_date.getFullYear();
  }
  format_currancy(amount) {
    if (amount == 0) {
      return '$0.00';
    }
    if (amount == undefined || amount == '') {
      return '';
    }
    return '$' + (amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  getDaysDifference(start_date, end_date) {
    var start_date = (new Date(start_date));
    var end_date = (new Date(end_date));

    // To calculate the time difference of two dates
    var Difference_In_Time = end_date.getTime() - start_date.getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    return Difference_In_Days;
  }

  getUserData() {
    axios.get(this.user_info_url)
      .then((response) => {
        this.context.checkLoginOnSGL();
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
          });

          if (localStorage.getItem('playing_video_id') && localStorage.getItem('playing_video_url') == window.location.pathname.replace(this.context.basePath, '') + window.location.search) {
            this.playVideoAPICall(localStorage.getItem('playing_video_id'));
          }
        } else {
        }
      }, (error) => {
      });
  }

  filterCompanyShows(shows) {
    if (this.context.company_id && this.context.company_id != -1) {
      return shows.filter((show) => show.customer_id == this.context.company_id)
    }
    else {
      return shows
    }
  }

  subscribeNow() {
    this.closeSubModal()
    this.setState({ loading: true })
    axios.post(this.sgl_webservice_subscription, {
      subscription_option: this.state.ios_sub_option,
      subscription_type: this.state.ios_sub_type,
      show_id: this.state.ios_sub_type == "single_event" ? this.state.selected_show : this.state.current_show,
      start_date: this.state.subscription_start_date,
      credit_card_option: this.state.selected_payment_method,
      company_id: this.context.company_id,
      single_show: this.state.single_show
    })
      .then(response => {
        this.setState({ loading: false })
        this.openSuccessSubscriptionModal()
        if (response.data.success) {
          if (this.state.ios_sub_type == "premium") {
            this.setState({ is_open_success_subscription_modal: true, subscription_response: `You have successfully subscribed to a Premium Subscription for ${this.state.ios_sub_option_days} days starting from ${this.state.subscription_start_date}.` })
          } else if (this.state.ios_sub_type == "single_event") {
            this.setState({ is_open_success_subscription_modal: true, subscription_response: `You have successfully subscribed to a Single Event Subscription for the show ${this.state.show_name}.` })
          }
          // get updated data
          this.getAllData();

        } else if (response.data.message) {
          this.setState({ is_open_success_subscription_modal: true, subscription_response: response.data.message });
        }

        else {
          this.setState({ is_open_success_subscription_modal: true, subscription_response: 'Some error occured while subscribing.' });
        }
      });
  }

  openSubscriptionModal() {
    // check if required fields are selected for subscription
    if ((this.state.ios_sub_option || (this.state.single_show && this.state.selected_show != -1)) && (this.state.selected_payment_method != -1 && this.state.ios_sub_type)) {
      this.setState({ is_open_subscription_modal: true, save_account_error_msg: '' });
      document.getElementById('save_account_warning').style.display = "block";
    }
    else {
      this.setState({ save_account_error_msg: 'Please select the required fields.' });
      document.getElementById('save_account_warning').style.display = "block";
    }
  }

  closeSubModal() {
    this.setState({ is_open_subscription_modal: false });
  }

  openSuccessSubscriptionModal() {
    this.setState({ is_open_success_subscription_modal: true });
  }

  closeSubSuccesModal() {
    this.setState({ is_open_success_subscription_modal: false });
  }

  // Add these methods right after closeSubSuccesModal() method
  toggleSidebar = () => {
    this.setState({
      sidebarCollapsed: !this.state.sidebarCollapsed
    });
  }

  toggleMobileMenu = () => {
    this.setState({
      isMobileMenuOpen: !this.state.isMobileMenuOpen
    });
  }

renderSidebarTabs = () => {
  return (
    <>
      <button 
        className="sidebar-back-button" 
        onClick={this.handleBackToShowGrounds}
      >
        <span className="back-icon">←</span>
        <span>Back to ShowGroundsLive</span>
      </button>
      
      {this.state.desktopTabs.map(tabObj => {
        if (tabObj.show) {
          return (
            <button 
              key={tabObj.name} 
              id={tabObj.name + '_sidebar_tab'} 
              className={"sidebar-tab-item " + (this.state.current_tab === tabObj.name ? 'active' : '')} 
              onClick={() => this.switchTab(tabObj.name)}
            >
              <span className="sidebar-tab-text">
                {tabObj.display}
                {tabObj.name === 'pending_requests' && this.context.pendingRequestsCount > 0 && (
                  <span className="notification-badge">{this.context.pendingRequestsCount}</span>
                )}
                {tabObj.name === 'my_agreements' && this.context.pendingAgreementsCount > 0 && (
                  <span className="notification-badge">{this.context.pendingAgreementsCount}</span>
                )}
              </span>
            </button>
          );
        }
        return null;
      })}
    </>
  );
}
    

handleCardClick = (optionId) => {
  this.setState({ios_sub_option: optionId});
  // Call your existing setIosSubOption if needed
  this.setIosSubOption({target: {value: optionId}});
}
  render() {
    if (this.state.loading) {
      return null;
    }

    return (
            <>
      {/* <h1 className="main-title" style={{marginTop:"15px", marginBottom:"10px", textAlign:"center"}}>My Account</h1> */}
      <div style={{display: "flex", gap: "10px"}}>
        <div className="my-account-sidebar">
          {/* <div className="sidebar-header">
            <h3 className="sidebar-title">Account Settings</h3>
          </div> */}
          <div className="sidebar-content">
            <nav className="sidebar-navigation">
              {this.renderSidebarTabs()}
            </nav>
          </div>
        </div>
        <div className="sgl-plugin myaccount-page myaccount-with-sidebar">
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
          {/* <div className="section-tab tab display_on_desktop">
          {
            this.state.desktopTabs.map(tabObj => {
              if (tabObj.show) {
                return (
                  <button key={tabObj.name} id={tabObj.name + '_tab'} className={"tablinks " + (this.state.current_tab == tabObj.name ? 'active' : '')} onClick={() => this.switchTab(tabObj.name)}>{tabObj.display}</button>
                );
              }
              return null
            })
          }
          </div> */}
        <div className="section-tab tab display_on_mobile">
          <div className="modern-mobile-menu" ref={this.mobileMenuRef}>
            <div 
              className={`mobile-menu-trigger ${this.state.isMobileMenuOpen ? 'active' : ''}`}
              onClick={this.toggleMobileMenu}
            >
              <span className="current-tab-text">
                {this.state.mobileTabs.find(tab => tab.name === this.state.current_tab)?.display || 'My Account'}
                {this.state.current_tab === 'pending_requests' && this.context.pendingRequestsCount > 0 && (
                  <span className="notification-badge">
                    {this.context.pendingRequestsCount}
                  </span>
                )}
                {this.state.current_tab === 'my_agreements' && this.context.pendingAgreementsCount > 0 && (
                  <span className="notification-badge">
                    {this.context.pendingAgreementsCount}
                  </span>
                )}
              </span>
              <div className="hamburger-icon">
                <i className={`fas ${this.state.isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
              </div>
            </div>
            
            {this.state.isMobileMenuOpen && (
              <>
                <div className="mobile-menu-overlay active" onClick={this.toggleMobileMenu}></div>
                <div className="mobile-menu-dropdown">
                  
                  <div 
                    className="mobile-back-button"
                    onClick={() => {
                      this.handleBackToShowGrounds();
                      this.toggleMobileMenu();
                    }}
                  >
                    <span className="back-icon">←</span>
                    <span>Back to ShowGroundsLive</span>
                  </div>       
                    {this.state.mobileTabs.map(tabObj => {
                      if (tabObj.show) {
                        return (
                          <div 
                            key={tabObj.name} 
                            className={`mobile-menu-item ${this.state.current_tab === tabObj.name ? 'active' : ''}`}
                            onClick={() => {
                              this.switchTab(tabObj.name);
                              this.toggleMobileMenu();
                            }}
                          >
                            {tabObj.display}
                            {tabObj.name === 'pending_requests' && this.context.pendingRequestsCount > 0 && (
                              <span className="notification-badge">{this.context.pendingRequestsCount}</span>
                            )}
                            {tabObj.name === 'my_agreements' && this.context.pendingAgreementsCount > 0 && (
                              <span className="notification-badge">{this.context.pendingAgreementsCount}</span>
                            )}
                          </div>
                        );
                      }
                      return null;
                    })}
                </div>
              </>
            )}
          </div>
        </div>
        <div id="my_account" className={"tabcontent account-container " + (this.state.current_tab == 'my_account' ? 'display_block' : 'display_none')}>
          <div >
            <div className="account-main-container">
              <div className="account-header">
                <h1>My Account</h1>
              </div>
              
              <div className="account-body">
                <form>
                  <div className="account-form-section">
                    <div className="account-section-title">Personal Information</div>
                    
                    <div className="account-form-row">
                      <div className="account-form-group">
                        <label>First Name <span style={{color: '#dc2626'}}>*</span></label>
                        <input 
                          type="text" 
                          name="first_name" 
                          id='txt_add_people_first_name' 
                          className="account-input" 
                          value={this.state.person_data.first} 
                          onChange={evt => this.updateNewPersonData(evt, 'first')} 
                        />
                      </div>
                      
                      <div className="account-form-group">
                        <label>Last Name <span style={{color: '#dc2626'}}>*</span></label>
                        <input 
                          type="text" 
                          name="last_name" 
                          id="txt_add_people_last_name"
                          className="account-input" 
                          value={this.state.person_data.last_name}
                          onChange={evt => this.updateNewPersonData(evt, 'last_name')}
                        />
                      </div>
                    </div>

                    <div className="account-form-row">
                      <div className="account-form-group">
                        <label>Address</label>
                        <input 
                          type="text" 
                          name="address" 
                          className="account-input" 
                          id='txt_add_people_address' 
                          value={this.state.person_data.address} 
                          onChange={evt => this.updateNewPersonData(evt, 'address')} 
                        />
                      </div>
                    </div>

                    <div className="account-form-row">
                      <div className="account-form-group">
                        <label>City</label>
                        <input 
                          type="text" 
                          name="city" 
                          id='txt_add_people_city' 
                          className="account-input" 
                          value={this.state.person_data.city} 
                          onChange={evt => this.updateNewPersonData(evt, 'city')} 
                        />
                      </div>
                      
                      <div className="account-form-group">
                        <label>State</label>
                        <input 
                          type="text" 
                          name="state" 
                          id="txt_add_people_state" 
                          className="account-input" 
                          value={this.state.person_data.state} 
                          onChange={evt => this.updateNewPersonData(evt, 'state')} 
                        />
                      </div>
                    </div>

                    <div className="account-form-row">
                      <div className="account-form-group">
                        <label>Postal Code</label>
                        <input 
                          type="text" 
                          name="postal_code" 
                          id='txt_add_people_postal_code'
                          className="account-input" 
                          value={this.state.person_data.postal_code}
                          onChange={evt => this.updateNewPersonData(evt, 'postal_code')}
                        />
                      </div>
                      
                      {!(this.state.person_data.phonenumber_verified) && (
                        <div className="account-form-group">
                          <label>{this.state.person_data.is_actual_horse_smc ? 'Mobile Number' : 'Telephone'}</label>
                          <input 
                            type="text" 
                            name="mobile_phone" 
                            id='txt_add_people_mobile_phone'
                            className="account-input" 
                            value={this.state.person_data.phonenumber}
                            onChange={evt => this.updateNewPersonData(evt, 'phonenumber')}
                          />
                          <div className="account-verify-mobile" style={{marginTop: '8px'}}>
                            <a 
                              id="verifyMobile_btn" 
                              className="account-verify-mobile" 
                              onClick={this.state.verify_mobile_please_wait ? null : this.verifyMobileNumber()}
                            >
                              {this.state.verify_mobile_please_wait ? <LoadingSpinner message="" /> : "Verify Mobile"}
                            </a>
                          </div>
                        </div>
                      )}
                      
                      {this.state.person_data.phonenumber_verified && <div></div>}
                    </div>
                  </div>

                  <div className="account-form-section">
                    <div className="account-section-title">Contact Information</div>
                    
                    {this.state.person_data.phonenumber_verified && (
                      <div className="account-info-card">
                        <div className="account-info-label">Mobile Number</div>
                        <div className="account-info-value">{this.state.person_data.phonenumber}</div>
                        <button 
                          type="button"
                          className="account-edit-button" 
                          onClick={this.openChangeMobileModal}
                        >
                          <svg className="account-edit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3Z"/>
                          </svg>
                          Edit
                        </button>
                      </div>
                    )}
                    
                    <div className="account-info-card">
                      <div className="account-info-label">Email Address</div>
                      <div className="account-info-value">{this.state.person_data.email_address}</div>
                      <button 
                        type="button"
                        className="account-edit-button" 
                        onClick={this.openChangeEmailModal}
                      >
                        <svg className="account-edit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3Z"/>
                        </svg>
                        Edit
                      </button>
                    </div>

                    <div className="account-info-card">
                      <div className="account-info-label">Password</div>
                      <div className="account-info-value">**********</div>
                      <button 
                        type="button"
                        className="account-edit-button" 
                        onClick={this.openChangePasswordModal}
                      >
                        <svg className="account-edit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3Z"/>
                        </svg>
                        Edit
                      </button>
                    </div>
                  </div>
                </form>

                <ReactModal
                  isOpen={this.state.is_open_change_mobile_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeChangeMobileModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Change Mobile Number</h2>
                    <button className="modern-close-btn" onClick={this.closeChangeMobileModal}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                  <div className="modern-modal-body">
                    <p className="change-mobile-modal-description">Please change mobile number.</p>
                    <p id='mobile_phone_error_msg' className='account-error-message' style={{ display: (this.state.mobile_phone_error.length > 0 ? 'block' : 'none') }}>{this.state.mobile_phone_error}</p>
                    

                    <div className="modern-form-group">
                      <label>Mobile Number</label>
                      <input className="modern-input" type="text" name="mobile_phone" value={this.state.updated_mobile_number} onChange={evt => this.updateMobileNumberValue(evt, 'phonenumber')} />
                    </div>
                  </div>
                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={this.closeChangeMobileModal}>
                      Close
                    </button>
                    <button 
                      id='change_mobile_button' 
                      className="modern-btn-primary" 
                      onClick={this.state.verify_mobile_modal_please_wait ? null : this.openVerifyMobileModel}
                    >
                      {this.state.verify_mobile_modal_please_wait ? <LoadingSpinner message="" /> : "Update"}
                    </button>
                  </div>
                </ReactModal>

                <ReactModal
                  isOpen={this.state.is_open_verify_mobile_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeVerifyMobileModel}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Verify Mobile</h2>
                    <button className="modern-close-btn" onClick={this.closeVerifyMobileModel}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                  <div className="modern-modal-body">
                    <p className="verify-mobile-modal-description">Please enter Verification Code</p>
                    <p id="verify_otp_error_summary" className="account-error-message" style={{ display: this.state.verify_otp_error_summary ? 'block' : 'none' }}>Please enter verification code sent to your phone.</p>
                    <div className="modern-form-group">
                      <label>Verification Code</label>
                      <input className="modern-input" type="text" maxlength="5" id="otp" name="otp" onChange={evt => this.updateVerificationCodeValue(evt)}></input>
                    </div>
                  </div>
                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={this.closeVerifyMobileModel}>
                      Close
                    </button>
                    <button 
                      id='verify_otp_button' 
                      className='modern-btn-primary' 
                      onClick={this.state.verify_otp_please_wait ? null : this.verifyMobileCode}
                    >
                      {this.state.verify_otp_please_wait ? <LoadingSpinner message="" /> : "Verify"}
                    </button>
                  </div>
                </ReactModal>

                <ReactModal
                  isOpen={this.state.is_open_change_email_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeChangeEmailModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Change Email</h2>
                    <button className="modern-close-btn" onClick={this.closeChangeEmailModal}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                  <div className="modern-modal-body">

                    <p className="change-email-modal-description">Please enter a new email.</p>
                    <p id='email_error_msg' className='account-error-message' style={{ display: this.state.email_error ? 'block' : 'none' }}>{this.state.email_error}</p>
                    
                    <div className="modern-form-group">
                      <label>New Email</label>
                      <input className="modern-input"  type="text" name="email" onChange={evt => this.updateEmailValue(evt)} />
                    </div>
                    <div className="modern-form-group">
                      <label>Verify Email</label>
                      <input className="modern-input"  type="text" name="verify_email" onChange={evt => this.updateVerifyEmailValue(evt)} />
                    </div>
                  </div>

                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={this.closeChangeEmailModal}>
                      Close
                    </button>
                    <button 
                      id='change_email_button' 
                      className="modern-btn-primary" 
                      onClick={this.state.change_email_please_wait ? null : this.changeEmail}
                    >
                      {this.state.change_email_please_wait ? <LoadingSpinner message="" /> : "Update"}
                    </button>
                  </div>
                </ReactModal>

                <ReactModal
                  isOpen={this.state.is_open_success_email_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeSuccessEmailModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Change Email</h2>
                    <button className="modern-close-btn" onClick={this.closeSuccessEmailModal}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>

                  <div className="modern-modal-body">
                    <p className="success-email-modal-description">Confirmation email has been sent to <b>{this.state.new_email}</b></p>
                  </div>

                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={this.closeSuccessEmailModal}>
                      Close
                    </button>

                  </div>
                </ReactModal>

                <ReactModal
                  isOpen={this.state.is_open_change_password_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeChangePasswordModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Change Password</h2>
                    <button className="modern-close-btn" onClick={this.closeChangePasswordModal}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>

                  <div className="modern-modal-body">
                    <p className="change-password-modal-description">Please enter a new password.</p>
                    <p id='password_error_msg' className='account-error-message' style={{ display: this.state.password_error ? 'block' : null }}>{this.state.password_error}</p>
                    <div className="modern-form-group">
                      <label>Current Password</label>
                      <input className="modern-input" type="password" name="old_password" onChange={evt => this.updateOldPasswordValue(evt)} />
                    </div>
                    <div className="modern-form-group">
                      <label>New Password</label>
                      <input className="modern-input" type="password" name="new_password" onChange={evt => this.updateNewPasswordValue(evt)} />
                    </div>
                    {this.state.new_password && (
                        <PasswordStrengthMeter password={this.state.new_password} />
                    )}
                    <div className="modern-form-group">
                      <label>Confirm Password</label>
                      <input className="modern-input" type="password" name="confirm_password" onChange={evt => this.updateConfirmPasswordValue(evt)} />
                    </div>
                  </div>

                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={this.closeChangePasswordModal}>
                      Close
                    </button>
                    <button 
                      className="modern-btn-primary" 
                      id='change_password_button' 
                      onClick={this.state.change_password_please_wait ? null : this.changePassword}
                    >
                      {this.state.change_password_please_wait ? <LoadingSpinner message="" /> : "Update"}
                    </button>
                  </div>
                </ReactModal>

                <ReactModal
                  isOpen={this.state.is_open_success_password_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeSuccessPasswordModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Change Password</h2>
                    <button className="modern-close-btn" onClick={this.closeSuccessPasswordModal}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>

                  <div className="modern-modal-body">
                    <p className="success-password-modal-description">Your password has been updated successfuly.</p>
                  </div>

                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={this.closeSuccessPasswordModal}>
                      Close
                    </button>
                  </div>
                </ReactModal>

                {/* MODALS FOR iOS SUBSCRIPTION CONFIRMATION AND SUCCESS */}
                <ReactModal
                  isOpen={this.state.is_open_subscription_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeSubModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>Please confirm your Subscription Purchase</h2>
                    <button className="modern-close-btn" onClick={() => this.closeSubModal()}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                  <div className="modern-modal-body">
                    <p className="subscription-modal-description">{this.state.ios_sub_type == "premium" ? `You are purchasing a Premium Subscription for ${this.state.ios_sub_option_days} days starting from ${this.state.subscription_start_date}.` :
                      `You are purchasing a Single Event Subscription for the show ${this.state.show_name}.`
                    }</p>
                  </div>
                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={() => this.closeSubModal()}>
                      Close
                    </button>
                    <button className="modern-btn-primary" onClick={() => this.subscribeNow()}>
                      Confirm
                    </button>
                  </div>
                </ReactModal>

                <ReactModal
                  isOpen={this.state.is_open_success_subscription_modal}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeSubSuccesModal}
                  className="modern-team-modal"
                  overlayClassName="modern-team-overlay account-modal-overlay"
                  ariaHideApp={false}
                >
                  <div className="modern-modal-header">
                    <h2>iOS Subscriptions</h2>
                    <button className="modern-close-btn" onClick={() => this.closeSubSuccesModal()}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </button>
                  </div>
                  <div className="modern-modal-body">
                    <p className="subscription-response-modal-description">{this.state.subscription_response}</p>
                  </div>
                  <div className="modern-modal-footer">
                    <button className="modern-btn-cancel" onClick={() => this.closeSubSuccesModal()}>
                      Close
                    </button>
                  </div>
                </ReactModal>
              </div>
            </div>
          </div>
        </div>

        <div id="pending_requests" className={"tabcontent " + (this.state.current_tab == 'pending_requests' ? 'display_block' : 'display_none')}>
          <PendingRequests />
        </div>

        <div id="team_management" className={"tabcontent " + (this.state.current_tab == 'team_management' ? 'display_block' : 'display_none')}>
          <TeamManagement />
        </div>

        <div id="manage_cards" className={"tabcontent payment-management-page " + (this.state.current_tab == 'manage_cards' ? 'display_block' : 'display_none')}>
          <div className="payment-management-container">
            <form style={{marginBottom: "0px"}}>
              {/* Platform Fee Payment Method Section */}
              {this.shouldShowPlatformFeeSection() && this.getDefaultCard() && (
                <div className="payment-section platform-fee-section platform-fee-payment-section"> {/* Add wrapper class */}
                  <h3 className="payment-section-title">ShowGrounds Platform Fee Payment Method</h3>
                  
                  <div className="platform-fee-info">
                    <p>This card will be automatically charged for:</p>
                    <ul>
                      <li>ShowGrounds platform fees for each entry you submit.</li>
                      <li>Charges will process automatically after each show.</li>
                    </ul>
                  </div>
                  <div className="selected-card-container">
                    <div className="selected-card-label">SELECTED CARD</div>
                    <div className="selected-card-details">
                      <span className="card-type-last4">
                        {this.getDefaultCard().type} ending in {this.getDefaultCard().card_lastfour}
                      </span>
                      <span className="card-name">
                        {this.getDefaultCard().name_on_card}
                      </span>
                      <span className="card-expiry">
                        Expires {this.getDefaultCard().card_exp}
                      </span>
                      <button 
                        className="payment-action-btn payment-btn-secondary change-card-btn" 
                        type="button"
                        onClick={this.openChangeDefaultCardModal}
                        >
                        Change
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {
                (this.state.ach_enabled) ?
                <>
                  {/* Bank Accounts Section */}
                  <div className="payment-section">
                    <div className="payment-section-header">
                      <h3 className="payment-section-title">Bank Accounts</h3>
                      <button 
                        className="payment-action-btn payment-btn-primary" 
                        type="button" 
                        onClick={() => this.props.navigate('/add-bank-account')}
                      >
                        Add Bank Account
                      </button>
                    </div>

                    {this.state.bank_accounts.length > 0 ? (
                      <div className="payment-table-container">
                        <table className="payment-table">
                          <thead>
                            <tr className="payment-table-header">
                              <th className="display_on_desktop">Account</th>
                              <th className="display_on_desktop">Bank Name</th>
                              <th className="display_on_desktop">Status</th>
                              <th className="display_on_desktop">Authorized</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.bank_accounts.map((data, index) => (
                              <tr key={index} className="payment-table-row">
                                <td className="display_on_mobile payment-mobile-card">
                                  <div className="payment-card-content">
                                    <div className="payment-row">
                                      <span className="payment-label">Account:</span>
                                      <span className="payment-value">{data.account_holder_name?`${data.account_holder_name} - `:""}*{data.last4}</span>
                                    </div>
                                    <div className="payment-row">
                                      <span className="payment-label">Bank Name:</span>
                                      <span className="payment-value">{data.bank_name}</span>
                                    </div>
                                    <div className="payment-row">
                                      <span className="payment-label">Status:</span>
                                      <span className={`payment-status ${data.status=='succeeded' ? 'status-verified' : 'status-pending'}`}>
                                        {data.status=='succeeded' ? (
                                          <>
                                            <div className="payment-status-icon">✓</div>
                                            <span>Verified</span>
                                          </>
                                        ) : (
                                          <>
                                            <div className="payment-status-icon"></div>
                                            <span>Pending</span>
                                          </>
                                        )}
                                      </span>
                                    </div>
                                    <div className="payment-row">
                                      <span className="payment-label">Authorized:</span>
                                      <span className="payment-value">{data.authorization_id > 0?"Yes":"No"}</span>
                                    </div>
                                  </div>
                                </td>
                                <td className="display_on_desktop">
                                  <div className="payment-account-info">
                                    <div className="payment-account-name">
                                      {data.account_holder_name?`${data.account_holder_name}`:""}
                                    </div>
                                    <div className="payment-account-number">*{data.last4}</div>
                                  </div>
                                </td>
                                <td className="display_on_desktop">
                                  <span className="payment-bank-name">{data.bank_name}</span>
                                </td>
                                <td className="display_on_desktop">
                                  <span className={`payment-status ${data.status=='succeeded' ? 'status-verified' : 'status-pending'}`}>
                                    {data.status=='succeeded' ? (
                                      <>
                                        <div className="payment-status-icon">✓</div>
                                        <span>Verified</span>
                                      </>
                                    ) : (
                                      <>
                                        <div className="payment-status-icon"></div>
                                        <span>Pending</span>
                                      </>
                                    )}
                                  </span>
                                </td>
                                <td className="display_on_desktop">
                                  <span className="payment-authorized">{data.authorization_id > 0?"Yes":"No"}</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="payment-empty-state">
                        <div className="empty-state-message">You have no bank account with your account.</div>
                      </div>
                    )}
                  </div>
                </>
                :<></>
              }

              {/* Credit Cards Section */}
              <div className="payment-section">
                <div className="payment-section-header">
                  <h3 className="payment-section-title">Credit Cards</h3>
                  <button 
                    className="payment-action-btn payment-btn-primary" 
                    type="button" 
                    onClick={this.openManageCardsModal}
                  >
                    {(this.state.payment_methods.length > 0) ? 'Manage Cards' : 'Add Credit Card'}
                  </button>
                </div>

                {this.state.payment_methods.length > 0 ? (
                  <div className="payment-table-container">
                    <table className="payment-table">
                      <thead>
                        <tr className="payment-table-header">
                          <th className="display_on_desktop">Card Number</th>
                          <th className="display_on_desktop">Name on Card</th>
                          <th className="display_on_desktop">Type</th>
                          <th className="display_on_desktop">Expiration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.payment_methods.map((data, index) => (
                          <tr key={index} className="payment-table-row">
                            <td className="display_on_mobile payment-mobile-card">
                              <div className="payment-card-content">
                                <div className="payment-row">
                                  <span className="payment-label">Card No.:</span>
                                  <span className="payment-value">xxxx-{data.card_lastfour}</span>
                                </div>
                                <div className="payment-row">
                                  <span className="payment-label">Name on Card:</span>
                                  <span className="payment-value">{data.name_on_card}</span>
                                </div>
                                <div className="payment-row">
                                  <span className="payment-label">Type:</span>
                                  <span className="payment-value">{data.type}</span>
                                </div>
                                <div className="payment-row">
                                  <span className="payment-label">Expiration:</span>
                                  <span className="payment-value">{data.card_exp}</span>
                                </div>
                              </div>
                            </td>
                            <td className="display_on_desktop">
                              <div className="cards-card-info-with-badge">
                                <span className="payment-card-number">xxxx-{data.card_lastfour}</span>
                              </div>
                            </td>
                            <td className="display_on_desktop">
                              <div className="payment-cardholder-name">{data.name_on_card}</div>
                            </td>
                            <td className="display_on_desktop">
                              <span className="payment-card-type">{data.type}</span>
                            </td>
                            <td className="display_on_desktop">
                              <span className="payment-expiry">{data.card_exp}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="payment-empty-state">
                    <div className="empty-state-message">You have no credit cards with your account.</div>
                  </div>
                )}
              </div>

              {/* Modal Container */}
              <div className="payment-modal-container">
                {(this.state.is_open_manage_card_modal) &&
                  <ManageCards
                    payment_methods={this.state.payment_methods}
                    check_card_email_phone_info={this.state.check_card_email_phone_info}
                    check_address_info={this.state.check_address_info}
                    is_open_manage_card_modal={this.state.is_open_manage_card_modal}
                    closeManageCardModal={this.closeSelectCardModal}
                    getPaymentMethods={this.getPaymentMethods}
                    ref={this.ManageCardsElement}
                    showDefaultSelection={this.shouldShowPlatformFeeSection()}
                  />
                }
                {/* Change default card modal */}
                {this.state.is_open_change_default_card_modal && (
                  <ChangeDefaultCardModal
                    isOpen={this.state.is_open_change_default_card_modal}
                    onClose={this.closeChangeDefaultCardModal}
                    paymentMethods={this.state.payment_methods}
                    currentDefaultId={this.state.defaultPaymentMethod?.fingerprint_id}
                    onSuccess={this.handleChangeDefaultCardSuccess}
                    checkCardEmailPhoneInfo={this.state.check_card_email_phone_info}
                    checkAddressInfo={this.state.check_address_info}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
        {/* My Agreements */}
        <div id="my_agreements" className={"tabcontent " + (this.state.current_tab == 'my_agreements' ? 'display_block' : 'display_none')}>
          <MyAgreements />
        </div>
        {/* My Invoices */}
        <div id="my_invoices" className={"tabcontent " + (this.state.current_tab == 'my_invoices' ? 'display_block' : 'display_none')}>
          <MyInvoices />
        </div>

        <div id="manage_people" className={"tabcontent " + (this.state.current_tab == 'manage_people' ? 'display_block' : 'display_none')}>
          <div className="wrapper-padding">
            <AssociatedPeople />
          </div>
        </div>
        <div id="manage_horses" className={"tabcontent " + (this.state.current_tab == 'manage_horses' ? 'display_block' : 'display_none')}>
          <div className="wrapper-padding">
            <AssociatedHorses />
          </div>
        </div>
        <div id="video_subscriptions" className={"tabcontent " + (this.state.current_tab == 'video_subscriptions' ? 'display_block' : 'display_none')} >
          <div className="video-subscriptions-container">
            
            {/* Header - Email Notifications Style */}
            <div className="section-header">
              <h2>Video Subscriptions</h2>
            </div>

            {/* Content */}
            <div className="subscriptions-wrapper">
              <div className="subscriptions-header">
                You have following Video Subscriptions
              </div>
              
              <div className="subscriptions-list">
                {(this.state.video_subscriptions.length > 0) ?
                  this.state.video_subscriptions.map((data, index) => {
                    return (
                      <div key={index} className="subscription-card">
                        <div className="card-header">
                          <div className="date-column">
                            <div className="date-display">
                              {((data.creation_date !== '0000-00-00') ? (this.format_date(data.creation_date)) : '')}
                            </div>
                          </div>
                          
                          {/* Title with ID now in header */}
                          <div className="subscription-title">
                            {(() => {
                              const title = data.title;
                              const idMatch = title.match(/\(#(\d+)\)$/);
                              if (idMatch) {
                                return (
                                  <>
                                    {title.replace(/\s*\(#\d+\)$/, '')}
                                    <span className="subscription-id-inline"> #{idMatch[1]}</span>
                                  </>
                                );
                              }
                              return title;
                            })()}
                          </div>
                          
                          {/* Price Column - Show desktop or mobile price based on original logic */}
                          <div className="price-column">
                            <div className="price-display desktop-price">
                              {data.VideoPaymentHistory.length > 0 ? data.VideoPaymentHistory[0].paid_amount : ''}
                            </div>
                            <div className="price-display mobile-price">
                              {data.price}
                            </div>
                          </div>
                        </div>

                        <div className="card-actions">
                          {/* Actions moved to right side with flexbox */}
                          <div className="actions-wrapper">
                            {/* Video Column */}
                            <div className="video-column">
                              {(this.getVideosList(data.sgl_id).length > 0) ?
                                <Popup trigger={
                                  <div className="video-action-btn play" title="Play Video" onClick={()=>this.playFirstVideoFromList(data.entryxclasses_uuid)}>
                                  </div>
                                } position="right center" on="hover" className="video-subsctiption-popup" 
                                arrow={false} // Remove arrow to prevent positioning issues
                                keepTooltipInside={true} // Keep popup within viewport
                                repositionOnResize={true}>
                                  <div>
                                    <ul className='popup-ul'>
                                      {this.getVideosList(data.sgl_id).map((v_data, index) => {
                                        return (
                                          <li key={index} className='class_list_li'>
                                            <a onClick={this.playVideo(v_data.sgl_id)}>
                                              {v_data.class_number} - {v_data.class_name}{this.getVideoTitle(v_data)}
                                            </a>
                                          </li>
                                        )
                                      })}
                                    </ul>
                                  </div>
                                </Popup>
                                :
                                ''
                              }
                            </div>
                            
                            {/* Actions Column */}
                            <div className="actions-column">
                              <a href={this.getVideoDownloadPath(data.sgl_id)} className="receipt-btn">
                                <img src={download_icon} className="download-icon" alt="Download" />
                                <span className="receipt-text">Receipt</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                  :
                  <div className="empty-state">
                    <h3>No subscription records found.</h3>
                  </div>
                }
              </div>
            </div>
          </div>
          <div>
            {(this.state.playing_video) &&
              <VideoPlayer
                is_open_play_video_modal={this.state.is_open_play_video_modal}
                is_open_do_subscription_modal={this.state.is_open_do_subscription_modal}
                is_download_subscription={false}
                video_to_play={this.state.video_to_play}
                is_admin={this.state.is_admin}
                closeModal={this.closeModal}
                closeSubscriptionModal={this.closeSubscriptionModal}
                playing_preview={false}
                play_video_path={this.state.video_to_play.video_url}
                playVideoAfterSubscribe={this.playVideoAfterSubscribe}
                VideoSubscriptionElement={this.VideoSubscriptionElement}
                ref={this.VideoPlayerElement}
              />
            }
          </div>
        </div>
        <div id="ios_subscriptions" className={"tabcontent ios-subscriptions " + (this.state.current_tab == 'ios_subscriptions' ? 'display_block' : 'display_none')}>
          <div className="ios-subscriptions-header">
            <h2>iOS Subscriptions</h2>
          </div>
          
          <div className="ios-subscription-content">
            {/* Current Status */}
            <div className="ios-current-status">
              <div className="ios-status-label">Current Status</div>
              <div className="ios-status-value">{this.state.ios_result.subscription_status}</div>
            </div>

            {/* Subscription Options Header */}
            <div className="ios-section-title">Subscription Options</div>

            {/* Tab Switcher */}
            <div className="ios-tab-container">
              <div className="ios-tab-toggle">
                <div 
                  className={`ios-tab-option ${this.state.ios_sub_type === 'premium' ? 'active' : ''}`}
                  onClick={() => this.setIosSubType({target: {value: 'premium'}})}
                >
                  Premium Subscription
                </div>
                <div 
                  className={`ios-tab-option ${this.state.ios_sub_type === 'single_event' ? 'active' : ''}`}
                  onClick={() => this.setIosSubType({target: {value: 'single_event'}})}
                >
                  Single Event
                </div>
              </div>
            </div>

            {/* Premium Subscription Details */}
            <div className={`ios-premium-details ${this.state.ios_sub_type === 'premium' ? 'active' : ''}`}>
              {/* Date picker with wrapper and icon */}
              <div className="ios-date-picker-section">
                <label className="ios-date-label">Subscription starting</label>
                <div className="ios-date-input-wrapper">
                  <div className="dropdown-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                      <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"/>
                      <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"/>
                      <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  {this.renderDatePicker()}
                </div>
              </div>
              
              <div className="ios-subscription-options">
                {this.state.subscription_options.map((subscription_option, index) => (
                  <div 
                    key={subscription_option.sgl_id} 
                    className={`ios-option-card ${this.state.ios_sub_option === subscription_option.sgl_id ? 'selected' : ''}`}
                    onClick={() => this.handleCardClick(subscription_option.sgl_id)}
                  >
                    {/* Hidden radio button for backend functionality */}
                    <input 
                      type="radio" 
                      id={'option_' + subscription_option.sgl_id} 
                      name="ios_sub_option"
                      value={subscription_option.sgl_id} 
                      onChange={this.setIosSubOption}
                      checked={this.state.ios_sub_option === subscription_option.sgl_id}
                      style={{display: 'none'}}
                    />
                    
                    <div className="ios-option-details">
                      <div className="ios-option-duration">
                        {subscription_option.sku}
                      </div>
                      <div className="ios-option-price">
                        ${subscription_option.ProductPrices[0].price}
                      </div>
                      <div className="ios-option-extend">
                        <div className="extend-label">extend till</div>
                        <strong>{this.getExtendDate(subscription_option.sku - 1)}</strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Single Event Details */}
            <div className={`ios-single-event-details ${this.state.ios_sub_type === 'single_event' ? 'active' : ''}`}>
              <div className="ios-show-selector">
                <label className="ios-show-label">Select Show</label>
                <div className="ios-show-select-wrapper">
                  <div className="dropdown-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                      <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" strokeWidth="2"/>
                      <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <select 
                    className="ios-show-select" 
                    value={this.state.selected_show} 
                    onChange={(e) => this.setSelectedShow(e)}
                  >
                    <option value="-1">Please Select</option>
                    {this.state.ios_result_shows.map((show, index) => {
                      if (show.subscribed == 0) {
                        return (
                          <option key={show.show_id} value={`${show.show_id}`}>
                            {show.show_name}
                          </option>
                        )
                      }
                    })}
                  </select>
                </div>
              </div>
            </div>

            {/* Billing Information */}
            <div className="ios-section-title">Billing Information</div>
            
            <div className="ios-billing-section">
              <div className="ios-payment-selector">
                <label className="ios-payment-label">
                  Credit Card <em className="required">*</em>
                </label>
                <div className="ios-payment-input-wrapper">
                  <div className="dropdown-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                      <line x1="1" y1="10" x2="23" y2="10" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <select 
                    id="credit_card" 
                    className="ios-payment-select" 
                    value={this.state.selected_payment_method} 
                    onChange={(e) => this.onPaymentMethodSelect(e)}
                  >
                    <option value="-1">Select Credit Card...</option>
                    {this.state.payment_methods.map((payment_method, index) => (
                      <option key={payment_method.sgl_id} value={`${payment_method.sgl_id}`}>
                        {payment_method.label}
                      </option>
                    ))}
                    <option value='ManageCards'>Manage Credit Cards</option>
                  </select>
                </div>
              </div>   
              <div className="ios-subscribe-container">
                <input 
                  type="button" 
                  className="ios-submit-button"
                  value="Subscribe Now" 
                  onClick={() => this.openSubscriptionModal()} 
                />
              </div>
            </div>
          </div>
        </div>
        <div id="email_notifications" className={"tabcontent email-notifications " + (this.state.current_tab == 'email_notifications' ? 'display_block' : 'display_none')}>
          <div className="email-notifications-header">
            <h2>Email Notifications</h2>
          </div>
          <div className="email-notification-content">
            {/* Show Notifications Section */}
            <div className="email-section-title">Show Notifications</div>
            <div className="email-notification-list">
              <div className="email-notification-item">
                <input 
                  type="checkbox" 
                  name="showNotifs" 
                  id="upcoming_shows_notification" 
                  checked={this.state.email_notifications.upcoming_shows_notification} 
                  onChange={e => this.updateEmailNotificationsData(e, 'upcoming_shows_notification')} 
                />
                <div className="email-notification-content-wrapper">
                  <label htmlFor="upcoming_shows_notification" className="email-main-label">
                    Alert me for upcoming shows
                  </label>
                  <div className="email-description">
                    Get notified about shows that are scheduled to start soon
                  </div>
                </div>
              </div>
              
              <div className="email-notification-item">
                <input 
                  type="checkbox" 
                  name="showNotifs" 
                  id="sgl_daily_schedule_email" 
                  checked={this.state.email_notifications.sgl_daily_schedule_email} 
                  onChange={e => this.updateEmailNotificationsData(e, 'sgl_daily_schedule_email')} 
                />
                <div className="email-notification-content-wrapper">
                  <label htmlFor="sgl_daily_schedule_email" className="email-main-label">
                    Send me show schedule
                  </label>
                  <div className="email-description">
                    Receive daily schedule updates via email
                  </div>
                </div>
              </div>
            </div>

            <div className="email-action-item">
              <button className="email-action-button sgl-button button" onClick={this.openShowCompaniesModal}>
                Select Show Companies
              </button>
            </div>

            {/* Promotions Section */}
            <div className="email-section-title">Promotions/Newsletters</div>
            <div className="email-notification-list">
              <div className="email-notification-item">
                <input 
                  type="checkbox" 
                  name="promotions" 
                  id="send_promotions" 
                  checked={this.state.email_notifications.send_promotions} 
                  onChange={e => this.updateEmailNotificationsData(e, 'send_promotions')} 
                />
                <div className="email-notification-content-wrapper">
                  <label htmlFor="send_promotions" className="email-main-label">
                    Receive promotions and discounts
                  </label>
                  <div className="email-description">
                    Get special offers and promotional content
                  </div>
                </div>
              </div>
              
              <div className="email-notification-item">
                <input 
                  type="checkbox" 
                  name="promotions" 
                  id="send_updates_newsletters" 
                  checked={this.state.email_notifications.send_updates_newsletters} 
                  onChange={e => this.updateEmailNotificationsData(e, 'send_updates_newsletters')} 
                />
                <div className="email-notification-content-wrapper">
                  <label htmlFor="send_updates_newsletters" className="email-main-label">
                    Receive updates/newsletters
                  </label>
                  <div className="email-description">
                    Stay informed with our latest news and updates
                  </div>
                </div>
              </div>
            </div>

            <ReactModal
              isOpen={this.state.is_open_show_companies_modal}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeShowCompaniesModal}
              className="modern-team-modal companies-list-modal"
              overlayClassName="modern-team-overlay"
              ariaHideApp={false}
            >
              <div className="modern-modal-header">
                <h2>Show Management Companies</h2>
                <button className="modern-close-btn" onClick={this.closeShowCompaniesModal}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
              <div className="modern-modal-body">
                <div className="add_modal_div email-companies-list">
                  {this.state.show_companies_list.map((company, index) => (
                    <div key={"company_" + company.URLpath} className="email-company-item">
                      <input 
                        type="checkbox" 
                        name="showCompany" 
                        id={"company_" + company.URLpath} 
                        checked={company.unsubscribed} 
                        onChange={e => this.updateEmailNotifCompaniesList(e, company.URLpath)} 
                      />
                      <label htmlFor={"company_" + company.URLpath}>
                        {company.name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className='modern-modal-footer'>
                <button className='modern-btn-cancel' onClick={this.closeShowCompaniesModal}>
                  Close
                </button>
              </div>
            </ReactModal>
          </div>
        </div>
        <div id="my_orders" className={"tabcontent " + (this.state.current_tab == 'my_orders' ? 'display_block' : 'display_none')}>

          <div className="wrapper-padding">
            <form>
              <ul className='mr-25'>
                <li className='entry_people_li'>
                  <p>
                    You have following Orders.
                  </p>
                </li>
                <li className='entry_people_li'>

                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%" }} className="table table-striped table-hover">
                      <tbody>
                        <tr className="sgl-primary-header">
                          <th className="display_on_mobile"></th>
                          <th className="display_on_desktop">Order #</th>
                          <th className="display_on_desktop">Date</th>
                          <th className="display_on_desktop">Status</th>
                          <th className="display_on_desktop">Total</th>
                          <th className="display_on_desktop"></th>
                        </tr>
                        {(this.state.orders_list.length > 0) ?
                          this.state.orders_list.map((data, index) => {
                            return (
                              <tr>
                                <td className="display_on_mobile mbl_custom_row">
                                  <p className="table_row_p">
                                    <span><strong>Order #:</strong><strong><a onClick={this.openSuccessOrderDetailModal(data.sgl_id)} > {data.sgl_id}</a></strong></span>
                                    <br></br>
                                    <span><strong>Date:</strong> {this.format_date(data.creation_date)}</span>
                                    <br></br>
                                    <span><strong>Status:</strong> {data.EntityStatus.status_name}</span>
                                    <br></br>
                                    <span><strong>Total:</strong> {data.Invoices.total_invoice_amount}</span>
                                    <br></br>
                                    <span style={{ float: "right", clear: "both", fontWeight: "bold" }}><strong><a href={this.getOrderInvoiveDownloadPath(data.invoice_id)}><img src={download_icon} className="download-icon" /> View Invoice</a></strong></span>
                                  </p>
                                </td>
                                <td className="display_on_desktop"><strong><a onClick={this.openSuccessOrderDetailModal(data.sgl_id)} >{data.sgl_id}</a></strong></td>
                                <td className="display_on_desktop">{this.format_date(data.creation_date)}</td>
                                <td className="display_on_desktop">{data.EntityStatus.status_name}</td>
                                <td className="display_on_desktop">{data.Invoices.total_invoice_amount}</td>

                                <td className="display_on_desktop"><strong><a href={this.getOrderInvoiveDownloadPath(data.invoice_id)}><img src={download_icon} className="download-icon" /> View Invoice</a></strong></td>


                              </tr>
                            )
                          })
                          :
                          <tr>
                            <td colSpan="4">No orders found.</td>
                          </tr>

                        }
                      </tbody>
                    </table>
                    <ReactModal
                      isOpen={this.state.is_open_order_detail_modal}
                      onAfterOpen={this.afterOpenModal}
                      onRequestClose={this.closeSuccessOrderDetailModal}
                      className="mymodal modal-width-responsive details-dialog"
                      overlayClassName="myoverlay"
                      ariaHideApp={false}
                    >

                      <h2>Order Details</h2>

                      <table className="details">
                        <tbody>
                          <tr>
                            <td><strong>Order Status:</strong></td>
                            <td >{this.state.order_detail.status_name}</td>
                          </tr>
                          <tr>
                            <td ><strong>Order Date:</strong></td>
                            <td >{this.format_date(this.state.order_detail.creation_date)}</td>
                          </tr>
                        </tbody>
                      </table>
                      <label className="sgl-label-border sgl-add_entry"><b>Products</b></label>
                      {(this.state.order_detail.products) &&
                        this.state.order_detail.products.map((data, index) => {
                          return (
                            <p className='ml-30'>{data}</p>
                          )
                        })
                      }

                      <label className="sgl-label-border sgl-add_entry"><b>Delivery Information</b></label>
                      <p className='new-line ml-30'>{this.state.order_detail.delivery_info ? this.state.order_detail.delivery_info.split("<br/>").join("\n") : ''}</p>
                      <label className="sgl-label-border sgl-add_entry"><b>Billing Information</b></label>
                      <p className='new-line ml-30'>{this.state.order_detail.billing_info ? this.state.order_detail.billing_info.split("<br/>").join("\n") : ''}</p>
                      {this.state.order_detail.gift_message &&
                        <label className="sgl-label-border sgl-add_entry"><b>Gift Order</b></label>
                      }
                      {this.state.order_detail.gift_message &&
                        <p className='ml-30'><strong>Gift Message: </strong> {this.state.order_detail.gift_message}</p>
                      }
                      {this.state.order_detail.recipient_email &&
                        <label className="sgl-label-border sgl-add_entry"><b>Recipient’s Email Address</b></label>
                      }
                      {this.state.order_detail.recipient_email &&
                        <p className='ml-30'><strong>Email: </strong> {this.state.order_detail.recipient_email}</p>
                      }
                      <label className="sgl-label-border sgl-add_entry"><b>Payment Method</b></label>
                      <table className="details no-border">
                        <tbody>
                          <tr>
                            <td><strong>Subtotal:</strong></td>
                            <td >{this.state.order_detail.cart_subtotal}</td>
                          </tr>
                          <tr>
                            <td ><strong>Shipping:</strong></td>
                            <td >{this.state.order_detail.shipment_cost}</td>
                          </tr>
                          {this.state.order_detail.card_fee != '$0.00' &&
                            <tr>
                              <td ><strong>Credit Card Processing Fee:</strong></td>
                              <td >{this.state.order_detail.card_fee}</td>
                            </tr>
                          }
                          <tr>
                            <td ><strong>Total:</strong></td>
                            <td >{this.state.order_detail.total}</td>
                          </tr>
                        </tbody>
                      </table>

                      <label className="sgl-label-border sgl-add_entry"></label>

                      {this.state.order_detail.payment_option != 'wire_transfer' &&

                        <table className="details no-border">
                          <tbody>
                            <tr>
                              <td><strong>Card Owner:</strong></td>
                              <td >{this.state.order_detail.card_owner}</td>
                            </tr>
                            <tr>

                              <td ><strong>Card Number:</strong></td>
                              <td >{this.state.order_detail.card_number}</td>
                            </tr>
                            <tr>

                              <td ><strong>Expiration:</strong></td>
                              <td >{this.state.order_detail.card_exp}</td>
                            </tr>
                          </tbody>
                        </table>
                      }

                      {this.state.order_detail.order_comments &&
                        <label className="sgl-label-border sgl-add_entry"><b>Order Comments</b></label>
                      }
                      {this.state.order_detail.order_comments &&
                        <p className='ml-30'>{this.state.order_detail.order_comments}</p>
                      }



                      <div className="continue-button-div">
                        <button className='right' onClick={this.closeSuccessOrderDetailModal}>
                          Close
                        </button>
                      </div>

                    </ReactModal>
                  </div>
                </li>
              </ul>
            </form>
          </div>

        </div>
        <div id="my_bookings" className={"tabcontent " + (this.state.current_tab == 'my_bookings' ? 'display_block' : 'display_none')}>

          <div className="wrapper-padding">
            <form>
              <ul className='mr-25'>
                <li className='entry_people_li'>
                  <p>
                    You have following Bookings.
                  </p>
                </li>
                <li className='entry_people_li'>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%" }} className="table table-striped table-hover">
                      <tbody>
                        <tr className="sgl-primary-header">
                          <th className="display_on_mobile"></th>
                          <th className="display_on_desktop">Booking #</th>
                          <th className="display_on_desktop">Accomodation</th>
                          <th className="display_on_desktop">Check-in Date</th>
                          <th className="display_on_desktop">Check-out Date</th>
                          <th className="display_on_desktop">Status</th>
                          <th className="display_on_desktop">Amount</th>
                        </tr>
                        {(this.state.bookings_list.length > 0) ?
                          this.state.bookings_list.map((data, index) => {
                            var EntityReservationBooking = data.EntityReservationBookings ? data.EntityReservationBookings[0] : {};
                            return (
                              <tr>
                                <td className="display_on_mobile mbl_custom_row">
                                  <p className="table_row_p">
                                    <span><strong>Booking #:</strong><strong><a onClick={this.openSuccessBookingDetailModal(data.sgl_id)} > {data.sgl_id}</a></strong></span>
                                    <br></br>
                                    <span><strong>Accomodation:</strong> {data.booking_entities}<br></br><a href={this.getCalendarPath(data.sgl_id, data.booking_entities)}><img src={calendar_icon} className="calendar-icon" /></a></span>
                                    <br></br>
                                    <span><strong>Check-in Date:</strong> {this.format_date(data.min_booking_start_date)}</span>
                                    <br></br>
                                    <span><strong>Check-out Date:</strong> {this.format_date(data.max_booking_end_date)}</span>
                                    <br></br>
                                    <span className={EntityReservationBooking.status == 'Cancelled' ? 'required' : ""}><strong>Status:</strong> {EntityReservationBooking.status}</span>
                                    <br></br>
                                    <span><strong>Amount:</strong> {this.format_currancy(data.total_amount)}</span>
                                  </p>
                                </td>
                                <td className="display_on_desktop"><strong><a onClick={this.openSuccessBookingDetailModal(data.sgl_id)} >{data.sgl_id}</a></strong></td>
                                <td className="display_on_desktop">{data.booking_entities}<br></br><a href={this.getCalendarPath(data.sgl_id, data.booking_entities)}><img src={calendar_icon} className="calendar-icon" /></a></td>
                                <td className="display_on_desktop">{this.format_date(data.min_booking_start_date)}</td>
                                <td className="display_on_desktop">{this.format_date(data.max_booking_end_date)}</td>
                                <td className={["display_on_desktop", EntityReservationBooking.status == 'Cancelled' ? 'required' : ""].join(' ')} >{EntityReservationBooking.status}</td>
                                <td className="display_on_desktop">{this.format_currancy(data.total_amount)}</td>
                              </tr>
                            )
                          })
                          :
                          <tr>
                            <td colSpan="4">No bookings found.</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                    <ReactModal
                      isOpen={this.state.is_open_booking_detail_modal}
                      onAfterOpen={this.afterOpenModal}
                      onRequestClose={this.closeSuccessBookingDetailModal}
                      className="mymodal modal-width-responsive details-dialog"
                      overlayClassName="myoverlay"
                      ariaHideApp={false}
                    >

                      <h2>Booking Details</h2>
                      <table className="details">
                        <tbody>
                          <tr>
                            <td><strong>Booking #: </strong></td>
                            <td> {this.state.booking_detail.id}</td>
                          </tr>
                          <tr>
                            <td><strong>Check-in: </strong></td>
                            <td> {this.format_date(this.state.booking_data.min_booking_start_date)}</td>
                          </tr>
                          <tr>
                            <td><strong>Check-out: </strong></td>
                            <td> {this.format_date(this.state.booking_data.max_booking_end_date)}</td>
                          </tr>
                          <tr>
                            <td><strong>Reservation: </strong></td>
                            <td> {this.state.booking_detail.booking_nights + ' night' + (this.state.booking_detail.booking_nights > 1 ? 's, ' : ', ') + this.state.booking_detail.total_bookings + ' ' + (this.state.booking_detail.slot_name ? this.state.booking_detail.slot_name : '') + (this.state.booking_detail.total_bookings > 1 ? 's' : '')}</td>
                          </tr>
                          <tr>
                            <td><strong>Accomodation: </strong></td>
                            <td> {this.state.single_booking.DirectoryType ? this.state.single_booking.DirectoryType.ReservationDirectories.name : ''}</td>
                          </tr>
                          {(this.state.booking_detail.total_bookings == 1) &&

                            <tr>
                              <td><strong>Folio #: </strong></td>
                              <td> {this.state.single_booking.Charges.invoice_id}</td>
                            </tr>
                          }
                          {(this.state.booking_detail.total_bookings == 1) &&
                            <tr>
                              <td><strong>Guest Name: </strong></td>
                              <td> {(this.state.single_booking.first_name || this.state.single_booking.last_name) ? this.state.single_booking.first_name + ' ' + this.state.single_booking.last_name : ''}</td>
                            </tr>
                          }
                          {(this.state.booking_detail.total_bookings == 1) &&
                            <tr>
                              <td><strong>Occupancy: </strong></td>
                              <td> {this.getOccupency(this.state.single_booking)}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                      {this.state.booking_detail.total_bookings > 1 &&
                        (this.state.booking_data.EntityReservationBookings && this.state.booking_data.EntityReservationBookings.length > 1) &&

                        this.state.booking_data.EntityReservationBookings.map((data, index) => {
                          return (
                            <div>
                              <label className="sgl-label-border sgl-add_entry"><b>Guest Information ( # {index + 1})</b></label>
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <td><strong>Folio #: </strong></td>
                                    <td> {data.Charges.invoice_id}</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Guest Name: </strong></td>
                                    <td> {(data.first_name || data.last_name) ? data.first_name + ' ' + data.last_name : ''}</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Occupancy: </strong></td>
                                    <td> {this.getOccupency(data)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          )
                        })
                      }

                      {(this.state.single_booking.early_checkin || this.state.single_booking.late_checkout) &&
                        <div>
                          <label className="sgl-label-border sgl-add_entry"><b>Special Request</b></label>
                          <table className="details">
                            <tbody>
                              {this.state.single_booking.early_checkin &&
                                <tr><td>&nbsp;</td><td>Early Check-in</td></tr>
                              }
                              {this.state.single_booking.late_checkout &&
                                <tr><td>&nbsp;</td><td>Late Check-out</td></tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      <label className="sgl-label-border sgl-add_entry"><b>Billing Detail</b></label>
                      <table style={{ width: "100%" }} className="table table-striped table-hover">

                        <tr className="sgl-primary-header">
                          <th className="display_on_mobile"></th>
                          <th style={{ width: "50%" }} className="display_on_desktop">Description</th>
                          <th className="display_on_desktop center-align">Nights</th>
                          <th className="display_on_desktop center-align">Units</th>
                          <th className="display_on_desktop right-align">Amount</th>
                        </tr>
                        {(this.state.booking_data.EntityReservationBookings && this.state.booking_data.EntityReservationBookings.length > 0) ?
                          <tbody>
                            <tr>
                              <td className="display_on_mobile mbl_custom_row">
                                <p className="table_row_p">
                                  <span><strong>Description:</strong> {"Booking in " + (this.state.single_booking.DirectoryType ? this.state.single_booking.DirectoryType.ReservationDirectories.name : '') + " from " + this.format_date(this.state.single_booking.booking_start_date) + " to " + this.format_date(this.state.single_booking.booking_end_date)}</span>
                                  <br></br>
                                  <span><strong>Nights:</strong> {this.getDaysDifference(this.state.single_booking.booking_start_date, this.state.single_booking.booking_end_date)}</span>
                                  <br></br>
                                  <span><strong>Units:</strong> {this.state.booking_detail.total_bookings}</span>
                                  <br></br>
                                  <span><strong>Amount:</strong> {this.format_currancy(this.state.booking_data.booking_charges_subtotal)}</span>
                                </p>
                              </td>
                              <td className="display_on_desktop">{"Booking in " + (this.state.single_booking.DirectoryType ? this.state.single_booking.DirectoryType.ReservationDirectories.name : '') + " from " + this.format_date(this.state.single_booking.booking_start_date) + " to " + this.format_date(this.state.single_booking.booking_end_date)}</td>
                              <td className="display_on_desktop center-align">{this.getDaysDifference(this.state.single_booking.booking_start_date, this.state.single_booking.booking_end_date)}</td>
                              <td className="display_on_desktop center-align">{this.state.booking_detail.total_bookings}</td>
                              <td className="display_on_desktop right-align">{this.format_currancy(this.state.booking_data.booking_charges_subtotal)}</td>
                            </tr>
                            {(this.state.booking_detail.booking_addons_row && this.state.booking_detail.booking_addons_row.length > 0) &&
                              this.state.booking_detail.booking_addons_row.map((data, index) => {
                                return (

                                  <tr>
                                    <td className="display_on_mobile mbl_custom_row">
                                      <p className="table_row_p">
                                        <span><strong>Description:</strong>  {data.addon_description}</span>
                                        <br></br>
                                        <span><strong>Nights:</strong> {data.booking_nights}</span>
                                        <br></br>
                                        <span><strong>Units:</strong>  {data.total_quantity}</span>
                                        <br></br>
                                        <span><strong>Amount:</strong>  {data.total_amount}</span>
                                      </p>
                                    </td>
                                    <td className="display_on_desktop">{data.addon_description}</td>
                                    <td className="display_on_desktop center-align">{data.booking_nights}</td>
                                    <td className="display_on_desktop center-align">{data.total_quantity}</td>
                                    <td className="display_on_desktop right-align">{data.total_amount}</td>
                                  </tr>

                                )
                              })

                            }
                            <tr>
                              <td className="display_on_mobile mbl_custom_row">
                                <p className="table_row_p">
                                  <span><strong>SubTotal:</strong> {this.format_currancy(Number(this.state.booking_data.booking_charges_subtotal) + this.state.booking_detail.add_on_sub_toal)}</span>
                                </p>
                              </td>
                              <td colSpan="3" className="display_on_desktop right-align"><strong>SubTotal</strong></td>
                              <td className="display_on_desktop right-align">{this.format_currancy(Number(this.state.booking_data.booking_charges_subtotal) + this.state.booking_detail.add_on_sub_toal)}</td>
                            </tr>
                            <tr>
                              <td className="display_on_mobile mbl_custom_row">
                                <p className="table_row_p">
                                  <span><strong>Tax:</strong> {this.format_currancy(Number(this.state.booking_data.booking_charges_tax) + this.state.booking_detail.add_on_tax_amount)}</span>
                                </p>
                              </td>
                              <td colSpan="3" className="display_on_desktop right-align"><strong>Tax</strong></td>
                              <td className="display_on_desktop right-align">{this.format_currancy(Number(this.state.booking_data.booking_charges_tax) + this.state.booking_detail.add_on_tax_amount)}</td>
                            </tr>
                            <tr>
                              <td className="display_on_mobile mbl_custom_row">
                                <p className="table_row_p">
                                  <span><strong>Total:</strong> {this.format_currancy(Number(this.state.booking_data.booking_charges_subtotal) + this.state.booking_detail.add_on_sub_toal + Number(this.state.booking_data.booking_charges_tax) + this.state.booking_detail.add_on_tax_amount)}</span>
                                </p>
                              </td>
                              <td colSpan="3" className="display_on_desktop right-align"><strong>Total</strong></td>
                              <td className="display_on_desktop right-align">{this.format_currancy(Number(this.state.booking_data.booking_charges_subtotal) + this.state.booking_detail.add_on_sub_toal + Number(this.state.booking_data.booking_charges_tax) + this.state.booking_detail.add_on_tax_amount)}</td>
                            </tr>
                            <tr>
                              <td className="display_on_mobile mbl_custom_row">
                                <p className="table_row_p">
                                  <span><strong>Payments:</strong> {this.format_currancy(this.state.booking_detail.payment_amount ? Number(this.state.booking_detail.payment_amount) : 0)}</span>
                                </p>
                              </td>
                              <td colSpan="3" className="display_on_desktop right-align"><strong>Payments</strong></td>
                              <td className="display_on_desktop right-align">{this.format_currancy(this.state.booking_detail.payment_amount ? Number(this.state.booking_detail.payment_amount) : 0)}</td>
                            </tr>
                            <tr>
                              <td className="display_on_mobile mbl_custom_row">
                                <p className="table_row_p">
                                  <span><strong>Amount Due:</strong> {this.format_currancy(Number(this.state.booking_data.booking_charges_subtotal) + this.state.booking_detail.add_on_sub_toal + Number(this.state.booking_data.booking_charges_tax) + this.state.booking_detail.add_on_tax_amount - (this.state.booking_detail.payment_amount ? Number(this.state.booking_detail.payment_amount) : 0))}</span>
                                </p>
                              </td>
                              <td colSpan="3" className="display_on_desktop right-align"><strong>Amount Due</strong></td>
                              <td className="display_on_desktop right-align">{this.format_currancy(Number(this.state.booking_data.booking_charges_subtotal) + this.state.booking_detail.add_on_sub_toal + Number(this.state.booking_data.booking_charges_tax) + this.state.booking_detail.add_on_tax_amount - (this.state.booking_detail.payment_amount ? Number(this.state.booking_detail.payment_amount) : 0))}</td>
                            </tr>
                          </tbody>
                          :
                          <tr>

                            <td colSpan="4" className="">No Bookings Found.</td>
                          </tr>

                        }


                      </table>


                      <div className="continue-button-div">
                        <button className='right' onClick={this.closeSuccessBookingDetailModal}>
                          Close
                        </button>
                      </div>

                    </ReactModal>
                  </div>
                </li>

              </ul>
            </form>
          </div>

        </div>
        <div id='save_account_warning' className={'required' + (this.state.save_account_error_msg.length ? '' : ' display_none')}>{this.state.save_account_error_msg}</div>
        <div id='save_account_success' className={this.state.save_account_success_msg ? '' : 'display_none'}>{this.state.save_account_success_msg}</div>
        {this.state.update_btn_section && <div className='continue-button-div' id='update-btn-section'>
          <input type="button" className='button' value="Update" onClick={this.saveEditAccount()} />
        </div>}
        <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
      </div>
      </div>
      </>
    )
  }
}
MyAccount.contextType = SglContext;

export default function (props) {
  const navigate = useNavigate();
  return <MyAccount {...props} navigate={navigate} />;
}